// 国际化工具
const translations = {
  zh: {
    // 通用
    'loading': '加载中...',
    'select': '选择',
    'save': '保存',
    'cancel': '取消',
    'confirm': '确认',
    'delete': '删除',
    'edit': '编辑',
    'create': '创建',
    'search': '搜索',
    'reset': '重置',
    'success': '成功',
    'error': '错误',
    'warning': '警告',
    'submit': '提交',
    'back': '返回',
    'yes': '是',
    'no': '否',
    
    // 导航菜单
    'dashboard': '工作台',
    'model_square': '模型广场',
    'api_keys': 'API 密钥',
    'bills': '账单记录',
    'top_up': '充值',
    'feedback': '工单反馈',
    'merchant_center': '商户中心',
    'affiliate': '商户中心',
    'referral': '拉新返利',
    'settings': '账户设置',
    'logout': '退出登录',
    
    // 用户信息
    'user': '用户',
    'admin': '管理员',
    
    // 工作台
    'account_overview': '账户概览',
    'balance': '账户余额',
    'total_usage': '累计消费',
    'api_calls': 'API 调用次数',
    'quick_actions': '快捷操作',
    'create_api_key': '创建 API Key',
    'view_bills': '查看账单',
    'top_up': '立即充值',
    'recent_activity': '最近动态',
    'usage_trend': '使用趋势',
    
    // API密钥
    'api_key_management': 'API 密钥管理',
    'api_key_desc': '管理您的 API 密钥，用于调用平台接口',
    'key_name': '密钥名称',
    'api_key': '密钥',
    'status': '状态',
    'created_at': '创建时间',
    'last_used': '最后使用',
    'actions': '操作',
    'active': '启用',
    'inactive': '禁用',
    'no_api_keys': '暂无 API 密钥',
    'create_first_key': '创建您的第一个 API 密钥',
    'key_created': '密钥创建成功',
    'key_deleted': '密钥删除成功',
    'copy_success': '复制成功',
    'copy_failed': '复制失败',
    'confirm_delete': '确认删除',
    'confirm_delete_msg': '确定要删除此 API 密钥吗？删除后无法恢复。',
    
    // 账单
    'bill_management': '账单管理',
    'bill_desc': '查看您的消费记录和充值记录',
    'bill_type': '账单类型',
    'type': '类型',
    'amount': '消费金额',
    'balance_before': '余额（消费前）',
    'balance_after': '余额（消费后）',
    'remark': '备注',
    'all': '全部',
    'consumption': '消费',
    'recharge': '充值',
    'refund': '退款',
    'no_bills': '暂无账单记录',
    
    // 对话框建议标签
    'suggestion_spring': '写一首关于春天的诗',
    'suggestion_quantum': '解释量子计算的原理',
    'suggestion_python': '帮我写一个Python爬虫',
    
    // 商户中心
    'affiliate_program': '商户中心',
    'affiliate_desc': '推广链接，赚取佣金',
    'affiliate_link': '推广链接',
    'your_invitation_link': '您的专属邀请链接',
    'referral_rewards_desc': '好友通过您的链接注册，您将获得拉新返利奖励',
    'merchant_referral_bonus': '商户拉新佣金',
    'friend_referral_bonus': '好友注册奖励',
    'commission_rate': '佣金比例',
    'total_commission': '累计佣金',
    'withdrawable': '可提现金额',
    'invited_users': '邀请用户数',
    'affiliate_rules': '加盟规则',
    'commission_records': '佣金记录',
    'withdraw': '提现',
    'apply_withdraw': '申请提现',
    'withdraw_amount': '提现金额',
    'withdraw_account': '收款账户',
    'withdraw_note': '提现说明',
    
    // 设置
    'account_settings': '账户设置',
    'basic_info': '基本信息',
    'email': '邮箱',
    'phone': '手机号',
    'change_password': '修改密码',
    'old_password': '原密码',
    'new_password': '新密码',
    'confirm_password': '确认密码',
    'password_mismatch': '两次密码输入不一致',
    'password_changed': '密码修改成功',
    'security_settings': '安全设置',
    'login_password': '登录密码',
    'enter_current_password': '请输入当前密码',
    'enter_new_password': '请输入新密码',
    'password_min_length': '密码至少8位',
    'password_hint_input': '至少8位，建议包含字母和数字',
    'confirm_new_password': '请确认新密码',
    'edit': '修改',
    
    // 充值
    'top_up_title': '账户充值',
    'select_amount': '选择金额',
    'custom_amount': '自定义金额',
    'payment_method': '支付方式',
    'alipay': '支付宝',
    'wechat': '微信支付',
    'bank_transfer': '银行转账',
    'proceed_payment': '去支付',
    
    // 返回官网
    'back_to_home': '返回官网',
    
    // Dashboard
    'account': '账号',
    'not_generated': '未生成',
    'service_status': '服务状态',
    'service_normal': '正常运行',
    'online_experience': '在线体验',
    'clear_chat': '清空对话',
    'start_chat': '开始与 AI 对话',
    'chat_hint': '在下方输入消息，按 Enter 发送，Shift+Enter 换行',
    'input_message': '输入消息...',
    'send': '发送',
    'streaming_warning': '正在生成中，请稍候',
    'api_call_failed': '调用失败',
    'api_call_error': '调用失败，请稍后重试',
    'select_key': '选择密钥',
    'create_key_short': '创建密钥',
    'all_providers': '全部厂商',
    'no_model_available': '暂无可用模型',
    'no_model_for_filter': '当前筛选条件下无可用模型',
    'history_conversations': '对话历史',
    
    // API Keys
    'email_mismatch': '邮箱不匹配',
    'api_key_reset': 'API Key 已重置',
    'reset_failed': '重置失败',
    'reset_failed_retry': '重置失败，请稍后重试',
    'api_key_management': 'API 密钥管理',
    'your_api_key': '您的 API Key',
    'reset_api_key': '重置 API Key',
    'reset_warning': '重置后原 Key 将立即失效，请确认操作',
    'confirm_email': '请输入您的邮箱确认',
    'code_example': '代码示例',
    
    // Consumption Records
    'consumption_records': '消费记录',
    'total_consumption': '累计消费',
    'total_records': '共',
    'records': '条记录',
    'record': '条记录',
    'no_consumption_records': '暂无消费记录',
    'recharge_records': '充值记录',
    'total_recharge': '累计充值',
    'no_recharge_records': '暂无充值记录',
    'transaction_records': '交易记录',
    'admin_adjustment': '后台调整',
    'model': '模型',
    'input_tokens': '输入Token',
    'output_tokens': '输出Token',
    
    // Settings
    'normal': '正常',
    'registered_at': '注册时间',
    'login_password': '登录密码',
    'password_hint': '建议定期修改密码以保障账户安全',
    'help_support': '帮助支持',
    'api_docs': 'API 接入文档',
    'api_docs_desc': '完整的 API 使用指南和示例代码',
    'view_docs': '查看文档',
    'billing_info': '计费说明',
    'billing_info_desc': '按 Token 使用量计费，精确计费',
    'learn_more': '了解详情',
    'tech_support': '技术支持',
    'contact_email': '遇到问题？请发送邮件至',
    'enter_current_password': '请输入当前密码',
    'enter_new_password': '请输入新密码',
    'password_min_length': '密码至少8位',
    'password_hint_input': '至少8位，建议包含字母和数字',
    'confirm_new_password': '请确认新密码',
    'saving': '保存中...',
    
    // Recharge
    'payment_success': '支付成功！余额已到账',
    'payment_cancelled': '支付已取消',
    'fetch_balance_error': '获取余额失败',
    'min_recharge': '最低充值金额为 $1',
    'create_order_failed': '创建支付订单失败',
    'creating_order': '正在创建支付订单...',
    'recharge_failed': '充值失败',
    'recharge_error': '充值请求失败，请稍后重试',
    'current_balance': '当前余额',
    'account_normal': '账户正常',
    'instant_credit': '充值即时到账',
    'select_payment_method': '选择支付方式',
    'credit_debit': '信用卡/借记卡',
    'or_custom_amount': '或自定义金额',
    'recharge_now': '立即充值',
    'payment_info': '支付说明',
    'payment_info_1': '支持信用卡、借记卡支付（通过 Stripe 安全支付）',
    'payment_info_2': '支持 PayPal 账户支付',
    'payment_info_3': '充值金额即时到账，可用于调用所有模型',
    'payment_info_4': '余额永久有效，不会过期',
    'payment_info_5': '如有问题，请联系客服',
    
    // Affiliate
    'fetch_affiliate_error': '获取代理信息失败',
    'referral_code_copied': '推广码已复制到剪贴板',
    'referral_link_copied': '推广链接已复制到剪贴板',
    'level_bronze': '铜牌代理',
    'level_silver': '银牌代理',
    'level_gold': '金牌代理',
    'level_platinum': '白金代理',
    'level_normal': '普通代理',
    'active_status': '活跃',
    'pending_status': '待激活',
    'consumption_amount': '消费金额',
    'my_commission': '我的佣金',
    'commission_income': '佣金收入',
    'withdrawal_type': '提现',
    'completed': '已完成',
    'processing': '处理中',
    'time': '时间',
    'users': '用户',
    'total': '累计',
    'copy': '复制',
    'referral_code': '推广码',
    'promo_info': '推广信息',
    'promo_tip': '分享推广链接，新用户注册后您将获得其消费的',
    'promo_tip_2': '作为佣金',
    'referred_users': '推荐用户',
    
    // API Keys
    'current_key': '当前密钥',
    'reset': '重置',
    'api_key_warning': '请妥善保管您的 API Key，不要在客户端代码或公开仓库中暴露。',
    'no_api_key': '未生成 API Key',
    'integration_guide': '接入指南',
    'openai_compatible': 'OpenAI 兼容接口',
    'openai_compatible_desc': '本平台提供 OpenAI 兼容的 API 接口，您可以：',
    'openai_feature_1': '直接使用 OpenAI SDK 调用（只需修改 baseURL 和 apiKey）',
    'openai_feature_2': '支持流式输出（SSE）',
    'openai_feature_3': '支持多模型切换，按实际使用 token 计费',
    'key_tip': '列表内是你的全部 API Key。API Key 仅在创建时可见可复制，请妥善保存。不要与他人共享你的 API Key，或将其暴露在浏览器或其他客户端代码中。为了保护你的账户安全，我们可能会自动禁用我们发现已公开泄露的 API Key。',
    'api_key_copied': 'API Key 已复制',
    'api_key_save_reminder': '请务必保存好您的 API Key！关闭此弹窗后将无法再次查看完整 Key。',
    'request_example': '请求示例',
    'copied': '已复制',
    'copy_code': '复制代码',
    'standard_api': '标准 API 格式',
    'sse_streaming': 'SSE 流式',
    'realtime_output': '支持实时输出',
    'pay_per_use': '按量计费',
    'accurate_billing': '精确到小数点后6位',
    'available_models': '可用模型',
    'model_hint': '在请求参数中指定 model 字段即可使用不同模型',
    'model_name': 'model',
    'display_name': '显示名称',
    'provider': '提供商',
    'streaming_output': '流式输出',
    'confirm_reset_api_key': '确认重置 API Key',
    'confirm_reset': '确认重置',
    'reset_irreversible': '此操作不可撤销！重置后旧密钥将立即失效。',
    'enter_email_confirm': '请输入您的邮箱',
    'to_confirm': '以确认',
    
    // Dashboard
    'created': '已创建',
    'create_now': '去创建',
    'create_call': '创建调用',
    'referral_bonus': '推广返利',
    'up_to_20': '最高20%',
    'new_chat': '新建对话',
    'select_model': '选择模型',
    'select_model_first': '请先选择模型',
    'fullscreen': '全屏模式',
    'exit_fullscreen': '退出全屏',
    'try_asking': '试试问我：',
    'stop': '终止',
    'confirm_edit': '确认编辑',
    'edit_confirm_msg': '编辑保存后，将删除该消息之后的所有内容并重新获取AI回复，是否继续？',
    'regenerate': '重新生成',
    'request_stopped': '已终止请求',
    'request_timeout': '请求超时',
    'balance_insufficient': '余额不足',
    'balance_insufficient_msg': '您的账户余额不足，无法完成此次请求。请前往充值页面充值后重试。',
    'balance_insufficient_tip': '新用户注册赠送免费额度',
    'credit_limit_exceeded': '额度超限',
    'credit_limit_exceeded_msg': '当前 API Key 的额度已用完，请前往 API Keys 页面调整额度设置或创建新的 Key。',
    'manage_api_keys': '管理 API Keys',
    'select_provider': '选择厂商',
    'all_providers': '全部厂商',
    
    // Affiliate
    'not_affiliate': '您还不是代理商，请联系管理员申请',
    'no_referrals': '暂无推荐用户',
    'no_commission_records': '暂无佣金记录',
    'withdraw_success': '提现申请已提交',
    'withdraw_failed': '提现失败',
    'enter_amount': '请输入金额',
    'min': '最低',
    'min_withdraw': '最低提现金额为 $10',
    'select_payment': '请选择支付方式',
    'enter_account': '请输入收款账户',
    'withdraw_account_placeholder': '邮箱或账户信息',

    // Model Square
    'model_square_title': '探索AI模型，你要的这里都有',
    'model_square_subtitle': '探索各种AI模型，找到最适合你需求的解决方案',
    'search_models': '搜索模型',
    'hot_models': '热门模型',
    'all_models': '全部模型',
    'model_type': '模型类型',
    'use_case': '应用场景',
    'clear_filters': '清除筛选',
    'price': '价格',
    'input_price': '输入',
    'output_price': '输出',
    'no_models_found': '没有找到匹配的模型',
    'try_adjusting': '尝试调整搜索条件或筛选器',
    'fetch_models_failed': '获取模型失败',
    'view_details': '查看详情',
    'start_chat': '开始对话',
    'tokens_per_1k': '每1K tokens',

    // Feedback
    'feedback_title': '工单反馈',
    'feedback_desc': '遇到问题？请提交工单，我们会尽快处理',
    'feedback_type': '反馈类型',
    'bug_report': 'Bug 反馈',
    'feature_request': '功能建议',
    'general_feedback': '一般反馈',
    'title': '标题',
    'description': '描述',
    'contact_info': '联系方式（选填）',
    'submit_feedback': '提交反馈',
    'feedback_success': '反馈提交成功',
    'feedback_success_msg': '感谢您的反馈，我们会尽快处理',
    'my_tickets': '我的工单',
    'ticket_status': '状态',
    'ticket_pending': '待处理',
    'ticket_processing': '处理中',
    'ticket_resolved': '已解决',
    'ticket_closed': '已关闭',
    'no_tickets': '暂无工单',
    'ticket_detail': '工单详情',
    'reply': '回复',
    'send_reply': '发送回复',

    // Merchant Center
    'merchant_title': '商户中心',
    'merchant_desc': '推广链接，赚取佣金',
    'referral_link': '推广链接',
    'copy_link': '复制链接',
    'commission_rate': '佣金比例',
    'total_commission': '累计佣金',
    'withdrawable': '可提现金额',
    'invited_users': '邀请用户数',
    'withdraw': '提现',
    'apply_withdraw': '申请提现',
    'withdraw_amount': '提现金额',
    'withdraw_account': '收款账户',
    'withdraw_note': '提现说明',
    'commission_records': '佣金记录',
    'no_commission': '暂无佣金记录',
    'commission_rules': '佣金规则',
    'rule_1': '通过您的推广链接注册的用户，其消费金额的 {rate} 将作为您的佣金',
    'rule_2': '佣金实时计算，可随时申请提现',
    'rule_3': '最低提现金额为 $10',

    // Dashboard
    'welcome_back': '欢迎回来',
    'quick_start': '快速开始',
    'chat_with_ai': '与 AI 对话',
    'explore_models': '探索模型',
    'view_api_keys': '查看 API Keys',
    'account_info': '账户信息',
    'service_status': '服务状态',
    'normal': '正常',
    'maintenance': '维护中',

    // API Keys
    'create_new_key': '创建新 Key',
    'key_name': 'Key 名称',
    'credit_limit': '额度限制',
    'no_limit': '不限制',
    'key_created': '创建成功',
    'key_deleted': '删除成功',
    'confirm_delete_key': '确定要删除这个 API Key 吗？',
    'delete_warning': '删除后无法恢复，使用此 Key 的应用将无法调用 API',
    'edit_key_name': '编辑 Key 名称',
    'save': '保存',
    'cancel': '取消',
    
    // API Keys Page
    'my_api_keys': '我的 API Keys',
    'create_key': '创建 Key',
    'name': '名称',
    'limit': '额度',
    'used': '已用/额度',
    'created': '创建时间',
    'actions': '操作',
    'disabled': '已禁用',
    'enable': '启用',
    'enabled': '已启用',
    'disable': '禁用',
    'delete': '删除',
    'unlimit': '不限',
    'no_keys_yet': '暂无 Key，点击上方按钮创建',
    'please_enter_key_name': '请输入 Key 名称',
    'key_name_example': '例如：开发测试、生产环境',
    'key_name_hint': '为 Key 设置一个容易识别的名称，方便管理不同场景的用量',
    'optional': '可选',
    'credit_limit_hint': '设置额度后，该 Key 的累计用量达到此额度将自动禁用',
    'current_balance': '当前账户余额',
    'available_credit': '剩余可用额度',
    'no_available_credit': '您的其他 Key 已占用全部额度，无法再设置新额度',
    'zero_no_limit': '0 表示不限制额度',
    'key_created_success': 'Key 创建成功',
    'copy_and_close': '复制并关闭',
    'close': '关闭',
    'copy_save_key': '请立即复制保存 Key',
    'key_show_once': '此 Key 只显示一次，之后无法再次查看完整内容',
    'update_success': '更新成功',
    'update_failed': '更新失败',
    'update_failed_retry': '更新失败，请稍后重试',
    'created_success_copy': '创建成功，请复制保存',
    'created_failed': '创建失败',
    'created_failed_retry': '创建失败，请稍后重试',
    'deleted_success': '删除成功',
    'deleted_failed': '删除失败',
    'deleted_failed_retry': '删除失败，请稍后重试',
    'operation_failed': '操作失败',
    'operation_failed_retry': '操作失败，请稍后重试',
    'i_have_saved': '我已保存',
    'please_enter_new_name': '请输入新名称',
    'key_updated': 'Key 已更新',

    // 代码示例 tabs
    'tab_curl': 'cURL',
    'tab_python': 'Python (OpenAI SDK)',
    'tab_nodejs': 'Node.js (OpenAI SDK)',

    // Bills
    'consumption_records': '消费记录',
    'recharge_records': '充值记录',
    'bonus_records': '奖励记录',
    'total_consumption': '累计消费',
    'total_recharge': '累计充值',
    'total_bonus': '累计奖励',
    'time': '时间',
    'type': '类型',
    'amount': '金额',
    'balance_before': '余额（消费前）',
    'balance_after': '余额（消费后）',
    'remark': '备注',
    'no_records': '暂无记录',
    'consumption': '消费',
    'recharge': '充值',
    'bonus': '奖励',
    
    // Bills Page
    'transaction_records': '交易记录',
    'order_no': '订单号',
    'online': '在线',
    'offline': '线下',
    'status': '状态',
    'pending': '待处理',
    'succeeded': '成功',
    'failed': '失败',
    'method': '方式',
    'manual': '手动',
    'referee_email': '被推荐人邮箱',
    'bonus_amount': '奖励金额',
    'completed': '已完成',
    'processing': '处理中',
    'cancelled': '已取消',
    'no_bonus_records': '暂无奖励记录，分享活动链接邀请好友注册可获得奖励',
    
    // Model Square
    'search_placeholder': '搜索模型名称、模型厂商、应用场景、描述等',
    'hot_models_title': '热门模型',
    'models_count': '个模型',
    'default_sort': '默认排序',
    'sort_by_size': '按尺寸',

    // Price Compare
    'home': '首页',
    'price_compare': '价格比较',
    'price_trend': '价格趋势',
    'price_compare_desc': '比较不同模型的价格，选择最具性价比的方案',
    'model_comparison': '模型对比',
    'compare_result_explain': '如何理解对比结果',
    'compare_green_label': '绿色标记',
    'compare_green_tip': '在选中模型中该指标价格最低',
    'compare_price_context': '输入价格和输出价格独立比较，找出每个类别的最优选择',
    'compare_overall_hint': '综合考虑价格和上下文长度，选择最适合您需求的模型',
    'compare_select_2_hint': '请选择至少2个模型进行对比分析',
    'compare_select_min_2': '选择多个模型进行综合评估，找到最适合您使用场景的方案',
    'compare_recommendation': '推荐建议',
    'compare_best_input': '{model}在输入价格上最具优势',
    'compare_no_best': '选择多个模型进行综合评估，找到最适合您使用场景的方案',
    'total_models': '模型总数',
    'selected_compare': '已选择',
    'providers_count': '供应商数量',
    'cheapest_input': '最低输入价',
    'with_price': '有价格',
    'model_list': '模型列表',
    'filter_by_provider': '按供应商筛选',
    'filter_by_type': '按类型筛选',
    'search_model': '搜索模型...',
    'selected': '已选',
    'select_compare': '选择',
    'compare': '对比',
    'select_models_for_trend': '请选择至少2个模型查看价格趋势',
    'quick_compare': '快速对比',
    'selected_models': '已选模型',
    'max_models_compare_warning': '最多可对比4个模型',
    'input_price': '输入价格',
    'output_price': '输出价格',
    'billing_type': '计费方式',
    'context_length': '上下文长度',
    'type': '类型',
    'per_token': '按Token',
    'per_token_video': '按Token (视频)',
    'per_image': '按张',
    'per_call': '按次',
    'per_char': '按字符',
    'free': '免费',
    'sort_by_price': '按价格',
    'sort_by_context': '按上下文长度',
    'max_compare_tip': '最多选择4个模型进行对比',
    'clear_all': '清除全部',
    'clear': '清除',
    'total': '共',
    'lowest_price': '最低价格标记',
    'select_models_hint': '选择至少2个模型进行比较',
    'ascending': '升序',
    'descending': '降序',
    'search_results': '搜索结果',
    'all_models': '全部模型',
    'no_more_results': '暂无更多结果',
    'release_date': '发布时间',
    'input': '输入',
    'output': '输出',
    'capabilities': '支持功能',
    'context': '上下文',
    'size': '尺寸',
    'no_description': '暂无描述',
    
    // Merchant Center
    'merchant_access_denied': '商户权限已禁用',
    'merchant_access_denied_desc': '您的商户权限已被管理员禁用，如有疑问请联系客服',
    'back_to_home': '返回首页',
    'merchant_invite_link': '商户专属邀请链接',
    'promo_code': '推广码',
    'invite_link': '邀请链接',
    'copy_link': '复制链接',
    'copy': '复制',
    'merchant_link_hint': '提示：通过此链接注册的用户会自动成为您的下线客户',
    'cannot_generate_link': '无法生成邀请链接',
    'available_campaigns': '可参与的平台活动',
    'campaign_hint': '以下活动允许商户参与，使用活动专属链接邀请用户可同时获得活动奖励和佣金',
    'campaign_bonus': '活动奖励',
    'bonus_wallet': '奖励钱包',
    'withdrawable_account': '可提现账户',
    'consumption_account': '消费账户',
    'min_recharge_required': '最低充值要求',
    'no_requirement': '无要求',
    'remaining_slots': '剩余名额',
    'unlimited': '无限制',
    'campaign_time': '活动时间',
    'ended': '已结束',
    'ongoing': '进行中',
    'closed': '已关闭',
    'campaign_link': '活动链接',
    'total_commission': '累计佣金',
    'withdrawable_balance': '可提现余额',
    'referral_count': '下线客户数',
    'commission_rate': '佣金比例',
    'bank_card_info': '银行卡信息',
    'add_bank_card': '添加银行卡',
    'edit_bank_card': '修改银行卡',
    'bank_name': '开户银行',
    'bank_branch': '支行名称',
    'account_name': '持卡人姓名',
    'account_number': '银行卡号',
    'no_bank_card': '暂未绑定银行卡',
    'add_now': '立即添加',
    'commission_withdraw': '佣金提现',
    'apply_withdraw': '申请提现',
    'min_withdraw': '最低提现',
    'applied': '已申请',
    'total_withdrawn': '累计已提现',
    'withdraw_hint_1': '提现申请提交后，平台将在1-3个工作日内完成审核',
    'withdraw_hint_2': '审核通过后，平台将通过银行卡进行线下打款',
    'withdraw_hint_3': '如有疑问，请联系平台客服',
    'referral_list': '下线客户列表',
    'no_referrals_hint': '暂无下线客户，复制邀请链接分享给好友吧',
    'commission_records': '佣金记录',
    'no_commission_hint': '暂无佣金记录，您的下线客户消费后会产生佣金',
    'withdrawal_records': '提现记录',
    'no_withdrawal_records': '暂无提现记录',
    'referral_type': '拉新佣金',
    'consumption_type': '消费佣金',
    'commission_pending': '已结算',
    'commission_paid': '已到账',
    'commission_cancelled': '已取消',
    'withdrawal_pending': '待审核',
    'withdrawal_approved': '已通过',
    'withdrawal_paid': '已打款',
    'withdrawal_rejected': '已拒绝',
    'processed_at': '处理时间',
    'save': '保存',
    'enter_bank_name': '请输入开户银行',
    'enter_bank_branch': '请输入支行名称',
    'enter_account_name': '请输入持卡人姓名',
    'enter_account_number': '请输入银行卡号',
    'account_number_invalid': '请输入正确的银行卡号（16-19位数字）',
    'remark': '备注',
    'enter_remark': '请输入备注信息（选填）',
    'withdrawal_apply': '申请佣金提现',
    'withdrawal_desc': '平台将在1-3个工作日内完成审核，审核通过后通过您绑定的银行卡进行线下打款。',
    'enter_amount': '请输入提现金额',
    'amount_format_invalid': '请输入正确的金额格式',
    'amount_exceeds_balance': '提现金额不能超过可提现余额',
    'amount_below_min': '提现金额不能少于',
    'receiving_bank': '到账银行',
    
    // Pagination
    'pagination_total': '{start}-{end} / {total}',
    'pagination_items_per_page': '/ 页',
    'pagination_jump_to': '跳至',
    'pagination_page': '页',
    'pagination_prev_page': '上一页',
    'pagination_next_page': '下一页',
    'per_page': '/ 页',
    'prev_page': '上一页',
    'next_page': '下一页',
    'jump_to': '跳至',
    'page': '页',

    // FullLayout Sidebar
    'expand_menu': '展开菜单',
    'collapse_menu': '收起菜单',
    'collapse': '收起',
    'back_to_console': '返回控制台',
    
    // Feedback
    'submit_ticket': '提交工单',
    'ticket_type': '类型',
    'ticket_content': '内容',
    'ticket_status': '状态',
    'submit_time': '提交时间',
    'view_conversation': '查看对话',
    'continue_conversation': '继续对话',
    'no_feedback_records': '暂无反馈记录',
    'submit_failed': '提交失败，请重试',
    'ticket_closed_warning': '工单已关闭，无法继续对话',
    'send_failed': '发送失败，请重试',
    'business_cooperation': '商务合作',
    'no_messages': '暂无消息记录',
    'ticket_closed_cannot_reply': '工单已关闭，无法继续对话',
    'me': '我',
    'customer_service': '客服',
    'contact_customer_service': '联系客服',
    'fetch_customer_service_failed': '获取客服配置失败',
    'wechat_service': '微信客服',
    'wechat_customer_id': '微信客服ID',
    'copy_wechat_customer_id': '复制微信客服ID',
    'wechat_customer_copied': '微信客服ID已复制',
    'model_recommend': '模型推荐',
    'name_optional': '姓名（可选）',
    'enter_name': '请输入您的姓名',
    'enter_email': '请输入您的邮箱',
    'enter_valid_email': '请输入有效的邮箱地址',
    'issue_description': '问题描述',
    'enter_issue_description': '请详细描述您遇到的问题',
    'ticket': '工单',
'enter_message': '输入消息...',
    
    // Message Status
    'sending': '发送中',
    'sent': '已发送',
    'delivered': '已送达',
    'retry': '重试',
    'reconnecting': '重新连接中...',
    'connection_lost': '连接已断开',
    'connection_restored': '连接已恢复',
    'message_syncing': '消息同步中...',
    'message_synced': '已同步',
    
    // Dashboard
    'create_key_short': '创建 Key',
    'all_providers': '全部厂商',
    'history_conversations': '历史对话',
    'search_conversation': '搜索对话...',
    'pin': '置顶',
    'rename': '重命名',
    'pinned': '已置顶',
    'enter_chat': '进入聊天',
    'no_matching_conversations': '未找到匹配的对话',
    'no_conversations': '暂无对话记录',
    'collapse_conversation_list': '收起对话列表',
    'expand_conversation_list': '展开对话列表',
    'video_generating': '视频生成中，点击查看状态',
    'processing': '处理中...',
    'confirm_delete_conversation': '确认删除对话',
    'delete_conversation_msg': '确定要删除此对话吗？删除后无法恢复。',
    'conversation_deleted': '对话已删除',
    'user_avatar': '用户头像',
    'speech_speed': '语速',
    'ai_assistant': 'AI助手',
    'video_browser_unsupported': '您的浏览器不支持视频播放',
    'refresh_status': '刷新状态',
    'task_id': '任务ID',
    'generated_image': '生成图片',
    'no_api_key': '您还没有 API Key',
    'no_api_key_msg': '要开始聊天，您需要先创建一个 API Key。',
    'no_api_key_step1': '点击侧边栏的 API 密钥 菜单',
    'no_api_key_step2': '点击 创建 API Key 按钮',
    'no_api_key_step3': '设置 Key 名称和额度限制',
    'no_api_key_step4': '创建完成后返回这里继续对话',
    'no_api_key_tip': '创建 Key 后，系统会自动选择它进行对话。',
    
    // Playground / 模型训练
    'playground': '模型训练',
    'model_training': '模型训练',
    'playground_desc': '测试和探索 AI 模型',
    'my_training': '我的训练',
    'continue_training': '继续训练',
    'use_now': '立即使用',
    'go_train': '去训练',
    'go_train_now': '去训练',
    'no_trained_models': '您还没有训练模型',
    'view_all': '查看全部',
    'save_training_model': '保存训练模型',
    'model_name': '模型名称',
    'enter_model_name': '请输入模型名称',
    'description': '描述',
    'enter_description': '描述这个配置的用途（可选）',
    'base_model': '基础模型',
    'current_params': '当前参数',
    'public_share': '公开分享',
    'public_share_desc': '开启后其他用户可以在模型广场看到此配置',
    'save_success': '训练模型已保存',
    'save_failed': '保存失败',
    'load_config': '已加载配置',
    'config_params': '的参数，可继续调整训练',
    'dialogue_cleared': '对话已清空',
    'copied_to_clipboard': '已复制到剪贴板',
    'conversation_saved': '对话已保存',
    'request_cancelled': '请求已取消',
    'request_failed': '请求失败',
    'load_failed': '加载失败',
    'model_selection': '模型选择',
    'parameter_config': '参数配置',
    'temperature_desc': '控制随机性。较低值更确定性，较高值更有创意',
    'max_tokens_desc': '最大生成 token 数',
    'top_p_desc': 'Nucleus 采样，控制考虑的 token 范围',
    'frequency_penalty_desc': '减少重复已出现的 token',
    'presence_penalty_desc': '鼓励讨论新话题',
    'stream_mode': '流式输出',
    'stream_desc': '流式输出，实时显示生成内容',
    'system_prompt': 'System Prompt',
    'enter_system_prompt': '设置系统提示词...',
    'start_conversation': '开始对话吧！选择一个模型，调整参数，然后发送消息。',
    'input_placeholder': '输入消息... (Shift+Enter 换行，Enter 发送)',
    'streaming_mode': '流式模式',
    'sync_mode': '同步模式',
    'uses': '次使用',
    'used_count': '已使用',
    'temperature': 'Temperature',
    'max_tokens': 'Max Tokens',
    'top_p': 'Top P',
    'frequency_penalty': 'Frequency',
    'presence_penalty': 'Presence',
    'click_load_config': '点击加载配置',
    'no_description': '暂无描述',
    'save_training_model_tip': '调试好参数后，点击"保存训练模型"按钮保存配置。',
    'save_training_model_tip2': '训练模型将显示在',
    'save_training_model_tip3': '中。',
    'load_models_failed': '加载模型列表失败',
    'trained_config_loaded': '已加载配置',
    'trained_config_params': '的参数，可继续调整训练',
    'config_loaded': '已加载配置',
    'config_params': '的参数',
    'enter_config_name': '请输入模型名称',
    'all_models': '全部模型',
    'all_providers': '全部厂商',
    'select_role': '选择角色',
    'select_role_placeholder': '选择一个预设角色（可选）',
    'you': '你',
    'select_provider': '选择厂商',
    // 数据流
    'data_flow': '数据流',
    'request_data': '请求数据',
    'response_data': '响应数据',
    'model_params_used': '使用的模型参数',
    'trained_config': '训练配置',
    'preset': '预设',
    'parameters': '参数',
    'actual_request_body': '实际请求体',
    'usage': '用量',
    'response_content': '响应内容',
    'no_response_yet': '暂无响应数据，请发送消息后查看',
    'data_flow_tip': '提示：此面板显示实际发送的请求参数和响应数据，方便调试和验证是否使用了正确的训练参数和预设角色。',
    
    // 用户指引
    'user_guide': '用户指引',
    'guide_welcome': '欢迎使用！让我们带你快速上手。',
    'step1_title': '浏览模型广场',
    'step1_desc': '在模型广场中浏览和筛选你需要的 AI 模型，了解各模型的功能和定价。',
    'step2_title': '模型训练 - 调试参数',
    'step2_desc': '在模型训练中选择模型，调整 temperature、max_tokens 等参数，找到最适合你的配置。',
    'step3_title': '在工作台测试',
    'step3_desc': '在当前工作台中使用配置好的参数进行实际对话测试，验证效果是否符合预期。',
    'step4_title': '获取 API Key 开始调用',
    'step4_desc': '测试没问题后，创建 API Key，通过代码或 API 文档集成 AI 能力到你的应用中。',
    'got_it': '知道了，开始使用',
    'guide_tip': '下次可在右上角菜单中查看指引',
    
    // 工作台模式
    'chat_mode': '聊天',
    'image_mode': '图片',
    'voice_mode': '语音',
    'video_mode': '视频',
    'embedding_mode': 'Embedding',
    // 输入框placeholder
    'image_prompt_placeholder': '输入图片描述...',
    'voice_prompt_placeholder': '输入要转换的文本...',
    'video_prompt_placeholder': '输入视频描述...',
    'default_prompt_placeholder': '输入文本...',
    // 参数名称
    'count': '数量',
    'voice_type': '音色',
    'duration': '时长',
    'seconds': '秒',
    // 音色选项
    'voice_clear_boy': '清少年男',
    'voice_clear_girl': '清少女',
    'voice_sweet_boy': '甜妹男',
    'voice_sweet_girl': '甜美女',
    'voice_cloud_boy': '云扬男',
    'voice_cloud_girl': '云扬女',
    'doubao_female': '豆包-女声',
    'doubao_male': '豆包-男声',
    // 多模态生成按钮
    'generate_image': '生成图片',
    'generate_voice': '生成语音',
    'generate_video': '生成视频',
    'generate_embedding': '生成向量',
    // 多模态结果消息
    'image_generation_failed': '图片生成失败',
    'image_generation_success': '图片生成成功！',
    'voice_synthesis_failed': '语音合成失败',
    'voice_synthesis_success': '语音合成成功！',
    'video_generation_failed': '视频生成失败',
    'video_generation_success': '视频生成完成！',
    'video_task_submitted': '视频生成任务已提交！',
    'image_task_submitted': '图片生成任务已提交！',
    'embedding_generation_failed': 'Embedding 生成失败',
    'embedding_generation_success': 'Embedding 生成成功！',
    'error_occurred': '错误',
    'try_later': '请稍后重试',
    'check_balance': '请检查余额或稍后重试',
    'video_wait_message': '请等待生成完成后查询状态...',
    'task_id': '任务ID',
    'prompt': '提示词',
    'model': '模型',
    'text': '文本',
    'voice': '音色',
    'dimensions': '向量维度',
    'first_10_dims': '向量前10维',
    // 视频状态查询
    'query_failed': '查询失败',
    'unknown_error': '未知错误',
    'checking_status': '正在检查状态...',
    'manual_check': '手动检查状态',
    'check_failed': '检查失败',
    'task_status': '任务状态',
    'task_expired': '任务已过期',
    'task_cancelled': '任务已取消',
    'video_status': '视频状态',
    'try_again_later': '请稍后再试',
    'continue_previous_content': '请继续完成上面的内容，从中断的地方继续。',
    
    // Batch Processing
    'batch_processing': '批量处理',
    'batch_processing_desc': '异步批量处理 API 请求，适合大规模数据处理、报告生成等场景',
    'create_batch': '创建批量任务',
    'batch_detail': '批量任务详情',
    'batch_create_hint': '请上传 JSONL 文件创建批量处理任务',
    'batch_tip_title': '批量处理说明',
    'batch_tip_1': '1. 支持 /v1/chat/completions 和 /v1/embeddings 端点',
    'batch_tip_2': '2. 需要上传 JSONL 格式的输入文件',
    'batch_tip_3': '3. 为保护您的数据隐私，结果文件自任务完成后保留 7 天，届时将自动永久删除，请及时下载',
    'batch_help_title': '批量处理使用说明',
    'batch_help_quick_start': '快速开始',
    'batch_help_prepare_file': '1. 准备 JSONL 文件',
    'batch_help_prepare_file_desc': '批量处理需要使用 JSONL 格式的文件，每行包含一个完整的请求对象。',
    'batch_help_param_desc': '参数说明',
    'batch_help_custom_id': '自定义标识符，用于标识每个请求',
    'batch_help_method': 'HTTP 方法，如 POST',
    'batch_help_url': 'API 端点路径，如 /v1/chat/completions',
    'batch_help_body': '请求体内容，与标准 API 调用相同',
    'batch_help_supported_api': '支持的 API 类型',
    'batch_help_api_note': '每个请求的 body 中需要指定具体的模型名称',
    'batch_help_example_chat': '示例：对话补全',
    'batch_help_view_result': '查看结果',
    'batch_help_view_result_desc': '任务完成后，点击"下载"按钮获取结果文件。结果文件同样是 JSONL 格式。',
    'batch_help_limit': '限制',
    'batch_help_limit_1': '每个文件最大 100MB',
    'batch_help_limit_2': '最大请求数根据账户类型而定',
    'batch_help_limit_3': '为保护数据隐私，结果文件自完成后保留 7 天，届时自动永久删除，请及时下载',
    'no_batches': '暂无批量任务',
    'create_first_batch': '创建第一个批量任务',
    'input_file': '输入文件',
    'output_file': '输出文件',
    'error_file': '错误文件',
    'confirm_cancel_batch': '确认取消批量任务',
    'cancel_batch_warning': '确定要取消此批量任务吗？此操作无法撤销。',
    'batch_cancelled': '批量任务已取消',
    'cancel_failed': '取消失败',
    'delete_batch_warning': '删除后任务及其输入输出文件将无法恢复，确认删除？',
    'delete_success': '删除成功',
    'delete_failed': '删除失败',
    'batch_name': '任务名称',
    'batch_type': '任务类型',
    'batch_created': '批量任务创建成功',
    'batch_notice': '注意事项',
    'batch_notice_1': 'JSONL 文件每行需包含有效的 request 对象',
    'batch_notice_3': '为保护数据隐私，结果文件自完成后保留 7 天，届时自动永久删除',
    'batch_tip_4': '3. 为保护您的数据隐私，结果文件自完成后保留 7 天，届时自动永久删除',
    'only_jsonl_allowed': '只能上传 JSONL 格式文件',
    'file_too_large': '文件大小不能超过 10MB',
    'please_upload_file': '请先上传 JSONL 文件',
    'jsonl_file': 'JSONL 文件',
    'click_or_drag_file': '点击或拖拽上传 JSONL 文件',
    'jsonl_format_hint': '支持 .jsonl 格式，每行一个 JSON 对象',
    'chat_completions': '聊天完成',
    'embeddings': '文本嵌入',
    'completion_window': '完成窗口',
    'hours': '小时',
    'detail': '详情',
    'download': '下载',
    'total': '总计',
    'progress': '进度',
    'completed_at': '完成时间',
    'remove': '移除',
    'endpoint': '接口类型',
    'refresh': '刷新',
    'upload_success': '文件上传成功',
    'upload_failed': '文件上传失败',
    'batch_total_tasks': '总任务数',
    'batch_success_count': '成功',
    'batch_failed_count': '失败',
    'batch_completion_rate': '完成率',
    'batch_task_id': '任务ID',
    'batch_timeline': '执行时间线',
    'batch_task_created': '任务创建',
    'batch_task_started': '开始处理',
    'batch_task_completed': '任务完成',
    'batch_task_failed': '任务失败',
    'batch_task_name_auto': '批量任务',
    'batch_result_expiry_notice': '为保护您的数据隐私，结果文件将在任务完成后 7 天自动永久删除，请及时下载保存',
    'batch_privacy_notice': '我们重视您的数据隐私：所有批处理文件仅存储在加密的临时存储中，不写入任何数据库，结果文件自完成后 7 天自动永久删除',
    'batch_download_result': '下载结果',
    'batch_success_rate': '成功率',
    'batch_name_auto_tooltip': '留空则自动生成',
    'batch_name_auto_placeholder': '留空自动生成',
    'help': '帮助',

    // 音频制作
    'audio_studio': '音频制作',
    'audio_studio_desc': 'AI 语音识别与语音合成',
    'speech_synthesis': '语音合成',
    'speech_recognition': '语音识别',
    'text_input': '文本输入',
    'audio_url_input': '音频URL输入',
    'enter_text': '请输入文本',
    'enter_audio_url': '请输入音频URL',
    'generate_speech': '生成语音',
    'generate_success': '生成成功',
    'tts_placeholder': '输入要合成语音的文本...',
    'select_voice': '选择音色',
    'speed': '语速',
    'language': '语言',
    'asr_url_hint': '支持 MP3/WAV/AAC，最长12小时，需可公开访问',
    'start_recognition': '开始识别',
    'transcribing': '转写中...',
    'transcription_result': '识别结果',
    'transcription_complete': '转写完成',
    'transcription_failed': '转写失败',
    'transcription_timeout': '转写超时，请重试',
    'task_submitted': '任务已提交，正在转写...',
    'select_model': '选择模型',
    'model_version': '模型版本',
    'history': '历史记录',
    'no_history': '暂无记录',
    'download': '下载',
    'copy_link': '复制链接',
    'copy_text': '复制文本',
    'upload_audio_file': '上传音频文件',
    'click_or_drag_upload': '点击或拖拽文件到此处上传',
    'upload_hint': '支持 MP3、WAV、AAC、M4A — 最大 100MB',
    'upload_success': '上传成功',
    'upload_failed': '上传失败',
    'upload_first': '请先上传或输入音频URL',
    'uploading': '上传中...',
    'or_enter_url': '或直接输入音频URL',
    'refresh': '刷新',
    'basic_synthesis': '基础合成',
    'voice_clone': '声音复刻',
    'voice_design': '声音设计',
    'upload_sample': '上传音频样本 (10~20秒)',
    'vc_upload_hint': 'WAV/MP3/M4A，≥24kHz 单声道，10~60秒，最大10MB',
    'upload_sample_first': '请先上传音频样本',
    'create_voice': '创建音色',
    'voice_created': '音色已创建',
    'create_voice_first': '请先创建自定义音色',
    'voice_name_placeholder': '音色名称（可选）',
    'voice_prompt_label': '音色描述',
    'voice_prompt_placeholder': '例如：年轻活泼的女性声音，语速较快，带有上扬语调，适合直播带货',
    'preview_text_label': '预览文本',
    'preview_text_placeholder': '用于试听生成音色的文本',
    'preview_audio': '试听音频',
    'start_recording': '从麦克风录音',
    'stop_recording': '停止录音',
    'or_upload_file': '— 或上传文件 —',
    'clear': '清空',
    'step_create_voice': '第一步：创建音色',
    'step_synthesize': '第二步：输入文字并合成',
    'saved_voices': '已保存的音色',
    'instructions_label': '语音指令控制',
    'instructions_placeholder': '例如：语速较快，激动活泼，带有上扬语调，适合直播带货',
    'volume': '音量',
    'voice_service': '语音服务',
    'voice_service_desc': 'AI 语音合成 / 复刻 / 设计 / 识别',
    'speech_synthesis': '语音合成',
    'speech_recognition': '语音识别',
    'basic_synthesis': '基础合成',
    'voice_clone': '声音复刻',
    'voice_design': '声音设计',
    'voice_library': '音色库',
    'text_to_speech': '文字转语音',
    'synth_model': '合成模型',
    'voice': '音色',
    'preview': '试听',
    'use_voice': '去合成',
    'debug_console': '调试台',
    'speed': '语速',
    'instructions_label': '指令控制',
    'instructions_placeholder': '指令控制：语速快、激动活泼、直播带货风格',
    'synthesize': '合成试听',
    'download': '下载',
    'copy_link': '复制链接',
    'history': '历史记录',
    'no_history': '暂无记录',
    'clear': '清空',
    'success': '成功',
    'failed': '失败',
    'processing': '处理中',
    'days_left': '天后过期',
    'hours_left': '小时后过期',
    'expiring_soon': '即将过期',
    'original_sound': '原始声音',
    'upload_audio': '上传音频',
    'live_record': '实时录音 — 20s以内',
    'stop_record': '停止',
    'record_hint': '请在弹出的浏览器提示中点击"允许"以完成实时录音',
    'need_script': '需要参考文案？点击展开',
    'record_script_title': '录音参考文案',
    'collapse': '收起',
    'voice_name': '音色名',
    'start_clone': '开始复刻',
    'start_design': '开始设计',
    'design_voice': '用文字描述创建新音色',
    'design_placeholder': '描述你想要的音色特征，例如：年轻活泼的女性声音，语速较快，带有上扬语调，适合直播带货',
    'preview_text': '试听文本（生成音色后用此文本试听效果）',
    'reclone': '重新复刻',
    'redesign': '重新设计',
    'go_synth': '去语音合成体验更多 →',
    'synth_trial': '合成试听',
    'upload_file': '上传音频文件',
    'start_recognition': '开始识别',
    'transcribing': '转写中...',
    'transcription_result': '识别结果',
    'copy_text': '复制文本',
    'detail': '详情',
    'my_clones': '我的复刻',
    'my_designs': '我的设计',
    'click_to_upload': '点击或拖拽上传',
    'click_to_upload2': '点击或拖拽文件上传',
    'uploaded': '已上传: ',
    'instr_supported': '当前模型支持指令',
    'instr_unsupported': '切换至 Instruct 模型启用指令',
    'mic_denied': '麦克风未授权',
    'synth_success': '合成成功',
    'synth_tag': '合成',
    'asr_tag': '转写',
    'live_record2': '实时录音',
    'or_upload_file': '或上传文件',
    'or_enter_url': '或输入音频URL',
    'voice_name_hint': '不超过16字符',
    'voice_input_placeholder': '输入文本，转换成逼真的语音，或点击上方快捷文本',
    'instr_placeholder': '描述想要的语气风格，例如：语速较快、激动活泼、适合直播带货',
    'play': '播放',
    'remove': '移除',
    'waiting_result': '(等待识别结果...)',
    'expired': '已过期',
    'expires_in': '后过期',
    'time_remaining': '剩余',
    'day_unit': '天',
    'hour_unit': '时',
    'min_unit': '分',
    'sec_unit': '秒',
    'source_label': '来源: ',
    'voice_label': '音色: ',
    'language_label': '语言: ',
    'speed_label': '语速: ',
    'clone_text_label': '输入文字合成音频，或点击上方快捷文本',
    'test_text_hint': '试听文本（生成音色后用此文本试听效果）',
    'quick_text': '你好，欢迎使用语音合成服务',
    // 灵感创作
    'creative_inspiration': '灵感创作',
    'creative_inspiration_desc': '使用 AI 生成精美图片和视频，释放你的创造力',
    'with_ref_video': '含参考视频',
    'enter_prompt_required': '请输入创作描述',
    'select_model_placeholder': '选择模型版本',
    'generating': '生成中...',
    'generation_history': '创作历史',
    'no_history': '暂无创作记录',
    'cleared': '已清除',
    'creative_hot': 'HOT',
    'video_creation': '视频创作',
    'video_cost_calculator': '视频成本计算器',
    'image_creation': '图片创作',
    'select_model_version': '选择模型版本',
    'creative_prompt_placeholder_video': '描述你想要生成的视频场景，例如：「一只橘猫在阳光下的草地上追逐蝴蝶，4K画质，电影质感，慢动作」',
    'creative_prompt_placeholder_image': '描述你想要生成的图片，例如：「一座漂浮在云端的未来城市，赛博朋克风格，霓虹灯光，超细节，8K分辨率」',
    'negative_prompt_label': '排除内容',
    'negative_prompt_tip': '描述你不希望在画面中出现的内容',
    'negative_prompt_placeholder': '例如：模糊、低画质、变形、丑陋、多余的手指...',
    'reference_image': '参考图片',
    'reference_image_max': '最多 {count} 张',
    'reference_image_btn': '参考图',
    'param_settings': '参数设置',
    'resolution': '分辨率',
    'duration_label': '时长',
    'fps_label': '帧率',
    'aspect_ratio': '画面比例',
    'guidance_scale': '引导强度',
    'custom_seed': '自定义Seed',
    'watermark_label': '水印',
    'output_size': '输出尺寸',
    'random_seed': '随机种子',
    'random': '随机',
    'advanced_params': '高级参数',
    'generate_count': '生成数量',
    'art_style': '艺术风格',
    'style_photorealistic': '写实摄影',
    'style_illustration': '精美插画',
    'style_anime': '二次元动漫',
    'style_oil_painting': '油画风格',
    'style_3d_render': '3D 渲染',
    'style_watercolor': '水彩画',
    'style_sketch': '素描速写',
    'style_pixel_art': '像素艺术',
    'generate_video_btn': '生成视频',
    'generate_image_btn': '生成图片',
    'video_generating_text': '视频生成中...',
    'image_generating_text': '图片生成中...',
    'no_models_available': '暂无可用的模型',
    'generation_history': '创作历史',
    'clear_history': '清空全部',
    'clear_prompt': '清空',
    'prompt_description': '创作描述',
    'seconds_unit': '秒',
    'unknown_model': '未知模型版本',
    'input_video_desc': '请输入视频描述',
    'input_image_desc': '请输入图片描述',
    'select_model_first': '请选择模型版本',
    'unknown_model_version': '未知模型版本',
    'video_task_submitted': '视频生成任务已提交，正在后台生成...',
    'image_task_submitted': '图片生成任务已提交，正在后台生成...',
    'generation_complete': '生成完成！',
    'generation_complete_video_msg': '视频生成完成！',
    'generation_complete_image_msg': '图片生成完成！',
    'generation_failed': '生成失败',
    'generation_failed_video': '视频生成失败',
    'generation_failed_image': '图片生成失败',
    'generation_failed_image_no_url': '图片生成失败: 未获取到图片URL',
    'cleared_all': '已清除全部记录',
    'queueing': '排队中',
    'generating_progress': '生成中',
    'completed': '已完成',
    'succeeded': '已完成',
    'failed': '失败',
    'canceled': '已取消',
    'video_label': '视频',
    'image_label': '图片',
    'clear': '清空',
    'network_error': '网络错误',
    'unknown_error': '未知错误',
    'checking_status': '正在检查状态...',
    'manual_check': '手动检查状态',
    'check_failed': '检查失败',
    'task_status': '任务状态',
    'task_expired': '任务已过期',
    'task_cancelled': '任务已取消',
    'browser_not_support_video': '您的浏览器不支持视频播放',
    'preview': '预览',
    'generation_time': '生成时间',
    'generation_duration': '生成耗时',
    'task_query_id': '任务查询ID',
    'image_count': '{count}张图片',
    'prev_image': '上一张',
    'next_image': '下一张',
    'copy_task_id': '复制ID',
    'copied': '已复制',
    'detail_info': '详细信息',
    'click_to_view_detail': '点击查看详情',
    'reference_images_used': '参考图片',
    'no_ref_images': '无',
    'material_files': '素材文件',
    'go_to_creative': '前往灵感创作',
    'use_creative_page_tip_image': '更多图片创作参数和模型选择，请前往"灵感创作"页面',
    'use_creative_page_tip_video': '更多视频创作参数和模型选择，请前往"灵感创作"页面',
    // 视频生成模式
    'video_mode_label': '生成模式',
    'mode_full_reference': '全能参考',
    'mode_full_reference_desc': '上传多媒体素材作为参考生成视频',
    'mode_start_end_frames': '首尾帧',
    'mode_start_end_frames_desc': '首尾图片参考，生成视频',
    'mode_smart_multiframe': '智能多帧',
    'mode_smart_multiframe_desc': '自定义多帧+转场描述',
    'ai_prompt_assistant': 'AI Prompt 助手',
    'ai_prompt_placeholder': '描述你想做什么视频，AI帮你生成专业提示词...',
    'ai_generate_btn': 'AI 生成',
    'ai_generating': 'AI 正在为你生成专业提示词...',
    'ai_generated_success': '提示词已生成！',
    'ai_generated_failed': '提示词生成失败',
    'ai_prompt_modal_title': 'AI Prompt 助手',
    'ai_prompt_modal_intro': '描述你想要生成的视频内容，AI 将为你生成专业的视频提示词',
    'ai_prompt_modal_placeholder': '例如：一只金毛寻回犬在海边奔跑，夕阳西下，慢动作，电影质感...',
    'ai_prompt_gen_btn': '生成',
    'ai_prompt_generating_status': '生成中...',
    'ai_prompt_generated_label': '生成的提示词（Prompt）：',
    'ai_prompt_negative_label': '负面提示词（Negative Prompt）：',
    'ai_prompt_regenerate': '重新生成',
    'ai_prompt_use': '使用',
    'ai_prompt_filled': '已填充到描述框',
    'ai_prompt_analyzing': 'AI 正在分析你的需求...',
    'max_keyframes_hint': '最多4帧（首帧 + 中间帧 + 尾帧）',
    'upload_first_frame': '首帧图片（必选）',
    'upload_last_frame': '尾帧图片（可选）',
    'upload_ref_video': '参考视频',
    'upload_ref_audio': '参考音频',
    'keyframe_list': '关键帧列表',
    'add_keyframe': '添加关键帧',
    'frame_n': '第 {n} 帧',
    'transition_desc_placeholder': '转场描述（从此帧过渡到下一帧的画面变化）',
    'last_frame_no_transition': '最后一帧（无转场描述）',
    'generate_audio_toggle': '生成有声视频（AI自动配音/音效）',
    'return_last_frame_toggle': '返回尾帧图（用于串联生成）',
    'at_least_2_keyframes': '智能多帧模式至少需要2个关键帧',
    'upload_first_frame_required': '请上传首帧图片',
    'total_duration': '总时长',
    'frame_count': '帧数',
    'add_frame': '添加帧',
    'opening_content': '开场内容',
    'opening_desc_placeholder': '开场描述，如：女孩微笑打招呼',
    'upload_image_short': '传图',
    'transition_desc_simple': '转场描述，如：转身离开',
    'prompt_auto_generated': '提示词由帧数据自动生成，无需手动输入',
    'max_count': '最多{count}个',
        'please_create_aigc_group_first': '请先在AIGC素材组创建分组',
    'fetch_asset_group_failed': '获取素材组失败，请重试',
    'no_asset_url_to_convert': '无可转换的素材URL',
    'converted_to_asset_group': '已转换到素材组',
    'liveness_verify_failed': '发起活体验证失败',
    'verification_failed': '验证失败',
    'prompts_generated': '已生成 {count} 组提示词！',
    'ai_request_failed': 'AI 请求失败',
    'referenced': '已引用',
    'enter_group_name': '请输入分组名称',
    'fetch_library_failed': '获取素材库失败',
    'generate_image_btn': '生成图片',
    'generate_video_btn': '生成视频',
    'creative_inspiration': '灵感创作',
        'reference_video': '参考视频',
    'reference_audio': '参考音频',
    'select_from_library': '从素材库选择',
    'select_from_library_video': '从素材库选择视频',
    'cleared_all_prefix': '已清空所有',
    'my_works': '我的作品',
    'aigc_asset_group': 'AIGC素材组',
    'real_person_group': '真人素材组',
    'convert_to_aigc_group': '转换到AIGC素材组',
    'select_target_group': '选择目标分组',
    'asset_name': '素材名称',
    'enter_asset_name': '请输入素材名称',
    'confirm_convert': '确认转换',
    'asset_group_list': '素材组列表',
    'back_to_group_list': '返回组列表',
    'group_name': '组名',
    'group_id': '组ID',
    'real_person_group_list': '真人素材组列表',
    'no_real_person_groups': '暂无真人素材组',
    'no_asset_groups': '暂无素材组',
    'no_assets_in_group': '组内暂无素材',
    'image_expiry_1h': '图片签名URL有效期1小时，请及时使用',
    'video_expiry_24h': '视频素材保留24小时，请及时下载保存',
    'upload_asset': '上传素材',
    'upload': '上传',
    'select_from_library_frame': '从素材库选择关键帧',
    'max_count': '最多{count}个',
    'group_count': '组数',
    'group': '组',
    'paste_asset_url': '粘贴素材URL',
    'select_from_works': '从作品选',
    'image_expired': '图片已过期',
    'audio': '音频',
    'asset_name': '素材名称',
    'enter_asset_name': '请输入素材名称',
    'create_real_person_group': '创建真人组（需实名）',
    'recently_generated': '最近生成，24h内可用',
    'remaining_time': '剩余',
    'submit_url': '提交URL',
    'reference': '引用',
    'create_real_person_group': '创建真人组（需实名）',
    'hours_short': '小时',
    'minutes_short': '分钟',
    'remark': '备注/描述',
    'optional': '可选',
    'liveness_verification': '真人实名验证',
    'confirm_delete_asset': '删除此素材?',
    'confirm_delete': '确定删除?',
    'delete_success': '已删除',
    'confirm': '确认',
    'group_created_success': '素材组创建成功',
    'asset_submitted': '素材已提交',
    'prompt_reference_hint_start': '提示词中用 ',
    'prompt_reference_hint_end': ' 指代参考素材（N为左侧缩略图序号）',
'go_creative': '前往灵感创作',
    'select_model_first': '请选择模型版本',
    'reference_video': '参考视频',
    'reference_audio': '参考音频',
    'select_from_library': '从素材库选择',
    'select_from_library_video': '从素材库选择视频',
    'cleared_all_prefix': '已清空所有',
    'my_works': '我的作品',
    'aigc_asset_group': 'AIGC素材组',
    'real_person_group': '真人素材组',
    'convert_to_aigc_group': '转换到AIGC素材组',
    'select_target_group': '选择目标分组',
    'asset_name': '素材名称',
    'enter_asset_name': '请输入素材名称',
    'confirm_convert': '确认转换',
    'asset_group_list': '素材组列表',
    'back_to_group_list': '返回组列表',
    'group_name': '组名',
    'group_id': '组ID',
    'real_person_group_list': '真人素材组列表',
    'no_real_person_groups': '暂无真人素材组',
    'no_asset_groups': '暂无素材组',
    'no_assets_in_group': '组内暂无素材',
    'image_expiry_1h': '图片签名URL有效期1小时，请及时使用',
    'video_expiry_24h': '视频素材保留24小时，请及时下载保存',
    'upload_asset': '上传素材',
    'upload': '上传',
    'select_from_library_frame': '从素材库选择关键帧',
    'max_count': '最多{count}个',
    'group_count': '组数',
    'group': '组',
    'paste_asset_url': '粘贴素材URL',
    'select_from_works': '从作品选',
    'image_expired': '图片已过期',
    'audio': '音频',
    'asset_name': '素材名称',
    'enter_asset_name': '请输入素材名称',
    'create_real_person_group': '创建真人组（需实名）',
    'recently_generated': '最近生成，24h内可用',
    'remaining_time': '剩余',
    'submit_url': '提交URL',
    'reference': '引用',
    'create_real_person_group': '创建真人组（需实名）',
    'hours_short': '小时',
    'minutes_short': '分钟',
    'remark': '备注/描述',
    'optional': '可选',
    'liveness_verification': '真人实名验证',
    'confirm_delete_asset': '删除此素材?',
    'confirm_delete': '确定删除?',
    'delete_success': '已删除',
    'confirm': '确认',
    'group_created_success': '素材组创建成功',
    'asset_submitted': '素材已提交',
    'prompt_reference_hint_start': '提示词中用 ',
    'prompt_reference_hint_end': ' 指代参考素材（N为左侧缩略图序号）',
'go_creative': '前往灵感创作',
    'mode_full_reference_disabled': '当前模型不支持全能参考模式',

    // 人物素材库
    'person_asset_warning': '含人物素材需先上传到素材库',
    'person_asset_desc': '涉及真人面孔的参考素材需先上传至素材库审核。',
    'manage_assets': '管理素材',
    'asset_library_title': '人物素材库管理',
    'asset_group': '素材分组',
    'new_group_name': '新分组名称',
    'create_group': '创建分组',
    'add_asset': '添加素材',
    'asset_url_placeholder': '素材图片 URL',
    'submit_asset': '提交素材',
    'asset_list': '素材列表',
    'select_group_first': '选择分组后查看素材',
    'reference': '引用',
    'asset_processing': '审核中',
    'asset_active': '可用',
    'asset_failed': '失败',
    'asset_upload_hint': '涉及真人面孔的素材需通过素材库审核后使用。上传素材后等待状态变为 Active 即可在生成中引用。',

    // 下载
    'downloading': '下载中...',
    'download_success': '下载完成',
    'download_failed': '下载失败',
    'packaging_zip': '打包中...',
    'download_all_zip': '打包下载全部',
    'download_image': '下载此图',
    'download_current': '下载当前图片',
    'download_video': '下载视频',

    // Presets
    'preset_management': '预设管理',
    'preset_market': '预设市场',
    'my_presets': '我的预设',
    'create_preset': '创建预设',
    'edit_preset': '编辑预设',
    'preset_name': '预设名称',
    'enter_preset_name': '请输入预设名称',
    'preset_description': '预设描述',
    'enter_description': '请输入预设描述',
    'preset_prompt': '预设提示词',
    'enter_prompt': '请输入提示词内容',
    'variables': '变量',
    'variables_placeholder': '例如: {{name}}, {{date}}',
    'binding_model': '绑定模型',
    'binding_model_placeholder': '留空表示不绑定特定模型',
    'trained_model': '训练模型',
    'trained_model_name': '训练模型',
    'trained_model_bound_model': '模型',
    'preset_label': '预设',
    'preset_model': 'Preset Model',
    'preset_bound_model': 'Preset Model',
    'visibility': '可见性',
    'public': '公开',
    'private': '私密',
    'search_preset': '搜索预设...',
    'all_categories': '全部分类',
    'cat_code': '编程',
    'cat_writing': '写作',
    'cat_analysis': '分析',
    'cat_product': '产品',
    'cat_education': '教育',
    'cat_research': '研究',
    'cat_translation': '翻译',
    'cat_others': '其他',
    'no_presets': '暂无预设',
    'use_preset': '使用预设',
    'using_preset': '使用预设中',
    // 研究相关预设
    'research_paper_analyzer': '论文分析助手',
    'research_paper_analyzer_desc': '帮助分析和总结学术论文，提取关键信息和研究方法',
    'literature_review': '文献综述生成器',
    'literature_review_desc': '辅助撰写文献综述，系统整理和评述相关研究',
    'data_analysis_helper': '数据分析助手',
    'data_analysis_helper_desc': '协助进行数据清洗、统计分析和可视化建议',
    // 预设参数说明
    'preset_params_guide': '预设参数说明',
    'preset_params_temperature': 'Temperature（温度）：控制输出的随机性。较低值使输出更确定性，较高值产生更多创意变化',
    'preset_params_max_tokens': 'Max Tokens（最大令牌数）：限制单次回复的最大长度，影响回答的详细程度',
    'preset_params_top_p': 'Top P（核采样）：另一种控制随机性的方法，值越低选择越集中',
    'preset_params_system_prompt': 'System Prompt（系统提示词）：定义AI助手的角色、行为规则和上下文背景',
    'usage_count': '使用次数',
    'created_at': '创建时间',
    'description': '描述',
    'view': '查看',
    'copy_success': '复制成功',
    'copy_failed': '复制失败',
    'make_public_success': '已设为公开',
    'make_private_success': '已设为私密',
    'load_failed': '加载失败',
    'create_success': '创建成功',
    'create_failed': '创建失败',
    'update_success': '更新成功',
    'update_failed': '更新失败',
    'delete_success': '删除成功',
    'delete_failed': '删除失败',
    'operation_failed': '操作失败',
    'confirm_delete': '确定要删除此预设吗？',
    'close': '关闭',
    // 点赞相关
    'my_liked_presets': '我赞过的',
    'like_count': '点赞数',
    'likes': '次赞',
    'like': '点赞',
    'unlike': '取消点赞',
    'like_success': '点赞成功',
    'unlike_success': '已取消点赞',
    'usage': '次使用',
    
    // Page Titles
    'user_console': '用户后台',
  },
  en: {
    // Common
    'loading': 'Loading...',
    'select': 'Select',
    'save': 'Save',
    'cancel': 'Cancel',
    'confirm': 'Confirm',
    'delete': 'Delete',
    'edit': 'Edit',
    'create': 'Create',
    'search': 'Search',
    'reset': 'Reset',
    'success': 'Success',
    'error': 'Error',
    'warning': 'Warning',
    'submit': 'Submit',
    'back': 'Back',
    'yes': 'Yes',
    'no': 'No',
    
    // Navigation
    'dashboard': 'Dashboard',
    'model_square': 'Model Square',
    'api_keys': 'API Keys',
    'bills': 'Bills',
    'top_up': 'Top Up',
    'feedback': 'Feedback',
    'merchant_center': 'Merchant Center',
    'affiliate': 'Merchant Center',
    'settings': 'Settings',
    'logout': 'Logout',
    
    // User
    'user': 'User',
    'admin': 'Admin',
    
    // Dashboard
    'account_overview': 'Account Overview',
    'balance': 'Balance',
    'total_usage': 'Total Usage',
    'api_calls': 'API Calls',
    'quick_actions': 'Quick Actions',
    'create_api_key': 'Create API Key',
    'view_bills': 'View Bills',
    'top_up': 'Top Up',
    'recent_activity': 'Recent Activity',
    'usage_trend': 'Usage Trend',
    'account': 'Account',
    'not_generated': 'Not generated',
    'service_status': 'Service Status',
    'service_normal': 'Running',
    'online_experience': 'Online Experience',
    'clear_chat': 'Clear Chat',
    'start_chat': 'Start Chat with AI',
    'chat_hint': 'Enter message below, press Enter to send, Shift+Enter for new line',
    'input_message': 'Type a message...',
    'send': 'Send',
    'streaming_warning': 'Generating, please wait',
    'api_call_failed': 'API call failed',
    'api_call_error': 'Call failed, please try again later',
    // 工作台模式
    'chat_mode': 'Chat',
    'image_mode': 'Image',
    'voice_mode': 'Voice',
    'video_mode': 'Video',
    'embedding_mode': 'Embedding',
    // 输入框placeholder
    'image_prompt_placeholder': 'Enter image description...',
    'voice_prompt_placeholder': 'Enter text to convert...',
    'video_prompt_placeholder': 'Enter video description...',
    'default_prompt_placeholder': 'Enter text...',
    // 参数名称
    'count': 'Count',
    'voice_type': 'Voice',
    'duration': 'Duration',
    'seconds': 's',
    // 音色选项
    'voice_clear_boy': 'Clear Boy',
    'voice_clear_girl': 'Clear Girl',
    'voice_sweet_boy': 'Sweet Boy',
    'voice_sweet_girl': 'Sweet Girl',
    'voice_cloud_boy': 'Cloud Boy',
    'voice_cloud_girl': 'Cloud Girl',
    'doubao_female': 'Doubao Female',
    'doubao_male': 'Doubao Male',
    // 多模态生成按钮
    'generate_image': 'Generate Image',
    'generate_voice': 'Generate Voice',
    'generate_video': 'Generate Video',
    'generate_embedding': 'Generate Embedding',
    // 多模态结果消息
    'image_generation_failed': 'Image generation failed',
    'image_generation_success': 'Image generated successfully!',
    'voice_synthesis_failed': 'Voice synthesis failed',
    'voice_synthesis_success': 'Voice synthesized successfully!',
    'video_generation_failed': 'Video generation failed',
    'video_generation_success': 'Video generated successfully!',
    'video_task_submitted': 'Video generation task submitted!',
    'embedding_generation_failed': 'Embedding generation failed',
    'embedding_generation_success': 'Embedding generated successfully!',
    'error_occurred': 'Error',
    'try_later': 'Please try again later',
    'check_balance': 'Please check your balance or try again later',
    'video_wait_message': 'Please wait for the generation to complete, then check the status...',
    'task_id': 'Task ID',
    'prompt': 'Prompt',
    'model': 'Model',
    'text': 'Text',
    'voice': 'Voice',
    'dimensions': 'Dimensions',
    'first_10_dims': 'First 10 dimensions',
    // 视频状态查询
    'query_failed': 'Query failed',
    'unknown_error': 'Unknown error',
    'video_status': 'Video status',
    'try_again_later': 'Please try again later',
    'continue_previous_content': 'Please continue completing the above content from where it was interrupted.',
    
    // Batch Processing
    'batch_processing': 'Batch Processing',
    'batch_processing_desc': 'Process API requests in batch, suitable for large-scale data processing',
    'batch_purpose': 'Batch Purpose',
    'batch_purpose_desc': 'Process large amounts of API requests asynchronously. Suitable for scenarios like data processing, report generation, and bulk content creation.',
    'create_batch': 'Create Batch',
    'batch_detail': 'Batch Detail',
    'batch_create_hint': 'Please upload a JSONL file to create a batch task',
    'batch_name': 'Task Name',
    'batch_type': 'Task Type',
    'batch_created': 'Batch task created successfully',
    'batch_notice': 'Notes',
    'batch_notice_1': 'Each line of the JSONL file must contain a valid request object',
    'batch_notice_3': 'To protect your data privacy, result files are retained for 7 days after completion and then permanently deleted',
    'batch_tip_4': '3. To protect your data privacy, result files are retained for 7 days after completion and then permanently deleted',
    'only_jsonl_allowed': 'Only JSONL format files are allowed',
    'file_too_large': 'File size cannot exceed 10MB',
    'please_upload_file': 'Please upload a JSONL file first',
    'jsonl_file': 'JSONL File',
    'click_or_drag_file': 'Click or drag to upload JSONL file',
    'jsonl_format_hint': 'Supports .jsonl format, one JSON object per line',
    'chat_completions': 'Chat Completions',
    'embeddings': 'Embeddings',
    'completion_window': 'Completion Window',
    'hours': 'hours',
    'detail': 'Detail',
    'download': 'Download',
    'total': 'Total',
    'progress': 'Progress',
    'completed_at': 'Completed At',
    'remove': 'Remove',
    'endpoint': 'Endpoint',
    'refresh': 'Refresh',
    'upload_success': 'File uploaded successfully',
    'upload_failed': 'File upload failed',
    'batch_total_tasks': 'Total Tasks',
    'batch_success_count': 'Success',
    'batch_failed_count': 'Failed',
    'batch_completion_rate': 'Completion Rate',
    'batch_task_id': 'Task ID',
    'batch_timeline': 'Timeline',
    'batch_task_created': 'Task Created',
    'batch_task_started': 'Processing Started',
    'batch_task_completed': 'Task Completed',
    'batch_task_failed': 'Task Failed',
    'batch_task_name_auto': 'Batch Task',
    'batch_result_expiry_notice': 'To protect your data privacy, result files will be automatically and permanently deleted 7 days after completion. Please download in time',
    'batch_privacy_notice': 'We value your data privacy: All batch files are stored only in encrypted temporary storage, never written to any database, and result files are automatically and permanently deleted 7 days after completion',
    'batch_download_result': 'Download Result',
    'batch_success_rate': 'Success Rate',
    'batch_name_auto_tooltip': 'Leave blank to auto-generate',
    'batch_name_auto_placeholder': 'Leave blank to auto-generate',
    'help': 'Help',

    // Audio Studio
    'audio_studio': 'Audio Studio',
    'audio_studio_desc': 'AI Speech Recognition & Synthesis',
    'speech_synthesis': 'Speech Synthesis',
    'speech_recognition': 'Speech Recognition',
    'text_input': 'Text Input',
    'audio_url_input': 'Audio URL Input',
    'enter_text': 'Please enter text',
    'enter_audio_url': 'Please enter audio URL',
    'generate_speech': 'Generate Speech',
    'generate_success': 'Generated successfully',
    'tts_placeholder': 'Enter text to synthesize speech...',
    'select_voice': 'Select Voice',
    'speed': 'Speed',
    'language': 'Language',
    'asr_url_hint': 'Supports MP3/WAV/AAC, up to 12h. File must be publicly accessible.',
    'start_recognition': 'Start Recognition',
    'transcribing': 'Transcribing...',
    'transcription_result': 'Transcription Result',
    'transcription_complete': 'Transcription complete',
    'transcription_failed': 'Transcription failed',
    'transcription_timeout': 'Transcription timeout, please retry',
    'task_submitted': 'Task submitted, transcribing...',
    'select_model': 'Select Model',
    'model_version': 'Model Version',
    'history': 'History',
    'no_history': 'No history yet',
    'download': 'Download',
    'copy_link': 'Copy Link',
    'copy_text': 'Copy Text',
    'upload_audio_file': 'Upload Audio File',
    'click_or_drag_upload': 'Click or drag file to this area to upload',
    'upload_hint': 'Supports MP3, WAV, AAC, M4A — max 100MB',
    'upload_success': 'Upload complete',
    'upload_failed': 'Upload failed',
    'upload_first': 'Please upload or enter an audio URL',
    'uploading': 'Uploading...',
    'or_enter_url': 'Or enter an audio URL directly',
    'refresh': 'Refresh',
    'basic_synthesis': 'Basic Synthesis',
    'voice_clone': 'Voice Clone',
    'voice_design': 'Voice Design',
    'upload_sample': 'Upload Audio Sample (10~20s)',
    'vc_upload_hint': 'WAV/MP3/M4A, ≥24kHz mono, 10~60s, max 10MB',
    'upload_sample_first': 'Please upload an audio sample first',
    'create_voice': 'Create Voice',
    'voice_created': 'Voice Created',
    'create_voice_first': 'Please create a custom voice first',
    'voice_name_placeholder': 'Voice name (optional)',
    'voice_prompt_label': 'Voice Description',
    'voice_prompt_placeholder': 'e.g. A young and lively female voice, fast pace, with a rising tone, suitable for livestream',
    'preview_text_label': 'Preview Text',
    'preview_text_placeholder': 'Text to preview the generated voice',
    'preview_audio': 'Preview Audio',
    'start_recording': 'Record from Microphone',
    'stop_recording': 'Stop Recording',
    'or_upload_file': '— or upload a file —',
    'clear': 'Clear',
    'step_create_voice': 'Step 1: Create Custom Voice',
    'step_synthesize': 'Step 2: Enter Text & Synthesize',
    'saved_voices': 'Saved Voices',
    'instructions_label': 'Voice Instructions',
    'instructions_placeholder': 'e.g. Fast pace, excited and lively, rising intonation, suitable for livestream',
    'volume': 'Volume',
    'voice_service': 'Voice Service',
    'voice_service_desc': 'AI Speech Synthesis / Clone / Design / Recognition',
    'speech_synthesis': 'Speech Synthesis',
    'speech_recognition': 'Speech Recognition',
    'basic_synthesis': 'Basic Synthesis',
    'voice_clone': 'Voice Clone',
    'voice_design': 'Voice Design',
    'voice_library': 'Voice Library',
    'text_to_speech': 'Text to Speech',
    'synth_model': 'Synthesis Model',
    'voice': 'Voice',
    'preview': 'Preview',
    'use_voice': 'Use',
    'debug_console': 'Debug Console',
    'speed': 'Speed',
    'instructions_label': 'Instructions',
    'instructions_placeholder': 'e.g. Fast pace, excited and lively, livestream style',
    'synthesize': 'Synthesize',
    'download': 'Download',
    'copy_link': 'Copy Link',
    'history': 'History',
    'no_history': 'No records',
    'clear': 'Clear',
    'success': 'Success',
    'failed': 'Failed',
    'processing': 'Processing',
    'days_left': 'days left',
    'hours_left': 'hours left',
    'expiring_soon': 'Expiring soon',
    'original_sound': 'Original Sound',
    'upload_audio': 'Upload Audio',
    'live_record': 'Record Live — 20s max',
    'stop_record': 'Stop',
    'record_hint': 'Please click "Allow" in the browser prompt to enable recording',
    'need_script': 'Need a reference script? Click to expand',
    'record_script_title': 'Recording Reference Scripts',
    'collapse': 'Collapse',
    'voice_name': 'Voice Name',
    'start_clone': 'Start Cloning',
    'start_design': 'Start Designing',
    'design_voice': 'Describe Your Voice',
    'design_placeholder': 'Describe the voice you want, e.g. A young lively female voice, fast pace, rising intonation, suitable for livestream',
    'preview_text': 'Preview Text (used to preview the generated voice)',
    'reclone': 'Re-clone',
    'redesign': 'Re-design',
    'go_synth': 'Go to Voice Synthesis →',
    'synth_trial': 'Synthesis Preview',
    'upload_file': 'Upload Audio File',
    'start_recognition': 'Start Recognition',
    'transcribing': 'Transcribing...',
    'transcription_result': 'Transcription Result',
    'copy_text': 'Copy Text',
    'detail': 'Details',
    'my_clones': 'My Clones',
    'my_designs': 'My Designs',
    'click_to_upload': 'Click or drag to upload',
    'click_to_upload2': 'Click or drag file to upload',
    'uploaded': 'Uploaded: ',
    'instr_supported': 'Current model supports instructions',
    'instr_unsupported': 'Switch to Instruct model for instructions',
    'mic_denied': 'Microphone access denied',
    'synth_success': 'Synthesis successful',
    'synth_tag': 'Synth',
    'asr_tag': 'ASR',
    'live_record2': 'Record Live',
    'or_upload_file': 'Or upload a file',
    'or_enter_url': 'Or enter audio URL',
    'voice_name_hint': 'Max 16 characters',
    'voice_input_placeholder': 'Enter text to convert to speech, or click quick text above',
    'instr_placeholder': 'Describe the tone, e.g. fast pace, excited and lively, suitable for livestream',
    'play': 'Play',
    'remove': 'Remove',
    'waiting_result': '(Waiting for result...)',
    'expired': 'Expired',
    'expires_in': 'remaining',
    'time_remaining': 'Remaining',
    'day_unit': 'd ',
    'hour_unit': 'h ',
    'min_unit': 'm ',
    'sec_unit': 's',
    'source_label': 'Source: ',
    'voice_label': 'Voice: ',
    'language_label': 'Language: ',
    'speed_label': 'Speed: ',
    'clone_text_label': 'Enter text to synthesize, or click quick text above',
    'test_text_hint': 'Preview text (used to hear the generated voice)',
    'quick_text': 'Hello, welcome to the speech synthesis service',
    // Creative Inspiration
    'creative_inspiration': 'Video/Image Studio',
    'creative_inspiration_desc': 'Generate stunning images and videos with AI, unleash your creativity',
    'with_ref_video': 'with ref video',
    'enter_prompt_required': 'Please enter a creative description',
    'select_model_placeholder': 'Select model version',
    'generating': 'Generating...',
    'generation_history': 'Creation History',
    'no_history': 'No creation records',
    'cleared': 'Cleared',
    'creative_hot': 'HOT',
    'video_creation': 'Video Creation',
    'video_cost_calculator': 'Token Estimator',
    'image_creation': 'Image Creation',
    'select_model_version': 'Select Model Version',
    'creative_prompt_placeholder_video': 'Describe the video scene you want to generate, e.g. "An orange cat chasing butterflies on a sunny grassland, 4K, cinematic, slow motion"',
    'creative_prompt_placeholder_image': 'Describe the image you want to generate, e.g. "A futuristic floating city in the clouds, cyberpunk style, neon lights, ultra detailed, 8K"',
    'negative_prompt_label': 'Exclude',
    'negative_prompt_tip': 'Describe what you don\'t want in the output',
    'negative_prompt_placeholder': 'e.g. blurry, low quality, distorted, ugly, extra fingers...',
    'reference_image': 'Reference Image',
    'reference_image_max': 'Max {count}',
    'reference_image_btn': 'Ref Image',
    'param_settings': 'Parameters',
    'resolution': 'Resolution',
    'duration_label': 'Duration',
    'fps_label': 'FPS',
    'aspect_ratio': 'Aspect Ratio',
    'guidance_scale': 'Guidance Scale',
    'custom_seed': 'Custom Seed',
    'watermark_label': 'Watermark',
    'output_size': 'Output Size',
    'random_seed': 'Random Seed',
    'random': 'Random',
    'advanced_params': 'Advanced Parameters',
    'generate_count': 'Count',
    'art_style': 'Art Style',
    'style_photorealistic': 'Photorealistic',
    'style_illustration': 'Illustration',
    'style_anime': 'Anime',
    'style_oil_painting': 'Oil Painting',
    'style_3d_render': '3D Render',
    'style_watercolor': 'Watercolor',
    'style_sketch': 'Sketch',
    'style_pixel_art': 'Pixel Art',
    'generate_video_btn': 'Generate Video',
    'generate_image_btn': 'Generate Image',
    'video_generating_text': 'Generating video...',
    'image_generating_text': 'Generating image...',
    'no_models_available': 'No models available',
    'generation_history': 'Creation History',
    'clear_history': 'Clear All',
    'clear_prompt': 'Clear',
    'prompt_description': 'Description',
    'seconds_unit': 's',
    'unknown_model': 'Unknown model version',
    'input_video_desc': 'Please enter video description',
    'input_image_desc': 'Please enter image description',
    'select_model_first': 'Please select a model version',
    'unknown_model_version': 'Unknown model version',
    'video_task_submitted': 'Video generation task submitted!',
    'image_task_submitted': 'Image generation task submitted!',
    'generation_complete': 'Generation complete!',
    'generation_complete_video_msg': 'Video generated successfully!',
    'generation_complete_image_msg': 'Image generated successfully!',
    'generation_failed': 'Generation failed',
    'generation_failed_video': 'Video generation failed',
    'generation_failed_image': 'Image generation failed',
    'generation_failed_image_no_url': 'Image generation failed: No image URL received',
    'cleared_all': 'All records cleared',
    'queueing': 'Queued',
    'generating_progress': 'Generating',
    'completed': 'Completed',
    'succeeded': 'Completed',
    'failed': 'Failed',
    'canceled': 'Canceled',
    'video_label': 'Video',
    'image_label': 'Image',
    'clear': 'Clear',
    'network_error': 'Network error',
    'unknown_error': 'Unknown error',
    'checking_status': 'Checking status...',
    'manual_check': 'Manual check',
    'check_failed': 'Check failed',
    'task_status': 'Task status',
    'task_expired': 'Task expired',
    'task_cancelled': 'Task cancelled',
    'browser_not_support_video': 'Your browser does not support video playback',
    'preview': 'Preview',
    'generation_time': 'Generation Time',
    'generation_duration': 'Duration',
    'task_query_id': 'Task ID',
    'image_count': '{count} images',
    'prev_image': 'Previous',
    'next_image': 'Next',
    'copy_task_id': 'Copy ID',
    'copied': 'Copied',
    'detail_info': 'Details',
    'click_to_view_detail': 'Click to view details',
    'reference_images_used': 'Reference Images',
    'no_ref_images': 'None',
    'material_files': 'Materials',
    'go_to_creative': 'Go to Creative',
    'use_creative_page_tip_image': 'For more image generation parameters and model selection, please visit the Creative Inspiration page',
    'use_creative_page_tip_video': 'For more video generation parameters and model selection, please visit the Creative Inspiration page',
    // Video generation modes
    'video_mode_label': 'Generation Mode',
    'mode_full_reference': 'Full Reference',
    'mode_full_reference_desc': 'Upload multimedia as reference for video generation',
    'mode_start_end_frames': 'Start/End Frames',
    'mode_start_end_frames_desc': 'First & last frame reference for video generation',
    'mode_smart_multiframe': 'Smart Multi-Frame',
    'mode_smart_multiframe_desc': 'Custom multi-frame + transition descriptions',
    'ai_prompt_assistant': 'AI Prompt Assistant',
    'ai_prompt_placeholder': 'Describe what video you want, AI generates professional prompts...',
    'ai_generate_btn': 'AI Generate',
    'ai_generating': 'AI is generating professional prompts...',
    'ai_generated_success': 'Prompt generated!',
    'ai_generated_failed': 'Prompt generation failed',
    'ai_prompt_modal_title': 'AI Prompt Assistant',
    'ai_prompt_modal_intro': 'Describe the video content you want, AI will generate professional video prompts for you',
    'ai_prompt_modal_placeholder': 'e.g., A golden retriever running on the beach, sunset, slow motion, cinematic quality...',
    'ai_prompt_gen_btn': 'Generate',
    'ai_prompt_generating_status': 'Generating...',
    'ai_prompt_generated_label': 'Generated Prompt:',
    'ai_prompt_negative_label': 'Negative Prompt:',
    'ai_prompt_regenerate': 'Regenerate',
    'ai_prompt_use': 'Use',
    'ai_prompt_filled': 'Filled into description',
    'ai_prompt_analyzing': 'AI is analyzing your requirements...',
    'max_keyframes_hint': 'Max 4 frames (first + middle + last)',
    'upload_first_frame': 'First Frame Image (required)',
    'upload_last_frame': 'Last Frame Image (optional)',
    'upload_ref_video': 'Reference Video',
    'upload_ref_audio': 'Reference Audio',
    'keyframe_list': 'Keyframe List',
    'add_keyframe': 'Add Keyframe',
    'frame_n': 'Frame {n}',
    'transition_desc_placeholder': 'Transition description (visual change from this frame to next)',
    'last_frame_no_transition': 'Last frame (no transition description)',
    'generate_audio_toggle': 'Generate audio (AI auto voice/SFX)',
    'return_last_frame_toggle': 'Return last frame (for chained generation)',
    'at_least_2_keyframes': 'Smart Multi-Frame mode requires at least 2 keyframes',
    'upload_first_frame_required': 'Please upload a first frame image',
    'total_duration': 'Total Duration',
    'frame_count': 'Frames',
    'add_frame': 'Add Frame',
    'opening_content': 'Opening Content',
    'opening_desc_placeholder': 'Opening description, e.g.: A girl smiles and waves',
    'upload_image_short': 'Upload',
    'transition_desc_simple': 'Transition description, e.g.: Turn around and walk away',
    'prompt_auto_generated': 'Prompt is auto-generated from frame data, no manual input needed',
    'max_count': 'Max {count}',
        'please_create_aigc_group_first': 'Please create an AIGC group first',
    'fetch_asset_group_failed': 'Failed to fetch asset groups, please retry',
    'no_asset_url_to_convert': 'No asset URL to convert',
    'converted_to_asset_group': 'Converted to asset group',
    'liveness_verify_failed': 'Failed to initiate verification',
    'verification_failed': 'Verification failed',
    'prompts_generated': '{count} prompt groups generated!',
    'ai_request_failed': 'AI request failed',
    'referenced': 'Referenced',
    'enter_group_name': 'Please enter group name',
    'fetch_library_failed': 'Failed to fetch library',
    'generate_image_btn': 'Generate Image',
    'generate_video_btn': 'Generate Video',
    'creative_inspiration': 'Video/Image Studio',
        'reference_video': 'Reference Video',
    'reference_audio': 'Reference Audio',
    'select_from_library': 'Select from Library',
    'select_from_library_video': 'Select Video from Library',
    'cleared_all_prefix': 'Cleared all',
    'my_works': 'My Works',
    'aigc_asset_group': 'AIGC Assets',
    'real_person_group': 'Real Person Assets',
    'convert_to_aigc_group': 'Convert to AIGC Group',
    'select_target_group': 'Select Target Group',
    'asset_name': 'Asset Name',
    'enter_asset_name': 'Enter asset name',
    'confirm_convert': 'Confirm Convert',
    'asset_group_list': 'Asset Group List',
    'back_to_group_list': 'Back to Groups',
    'group_name': 'Group Name',
    'group_id': 'Group ID',
    'real_person_group_list': 'Real Person Group List',
    'no_real_person_groups': 'No real person groups',
    'no_asset_groups': 'No asset groups',
    'no_assets_in_group': 'No assets in group',
    'image_expiry_1h': 'Image signed URLs expire in 1 hour',
    'video_expiry_24h': 'Video material kept for 24 hours',
    'upload_asset': 'Upload Asset',
    'upload': 'Upload',
    'select_from_library_frame': 'Select from Library',
    'max_count': 'Max {count}',
    'group_count': 'Groups',
    'group': 'group(s)',
    'paste_asset_url': 'Paste asset URL',
    'select_from_works': 'From Works',
    'image_expired': 'Image expired',
    'audio': 'Audio',
    'asset_name': 'Asset Name',
    'enter_asset_name': 'Enter asset name',
    'create_real_person_group': 'Create Group (Verification Required)',
    'recently_generated': 'Recently generated, available for 24h',
    'remaining_time': 'Remaining',
    'submit_url': 'Submit URL',
    'reference': 'Use',
    'create_real_person_group': 'Create Group (Verification)',
    'hours_short': 'h',
    'minutes_short': 'min',
    'remark': 'Remark/Description',
    'optional': 'Optional',
    'liveness_verification': 'Liveness Verification',
    'confirm_delete_asset': 'Delete this asset?',
    'confirm_delete': 'Confirm delete?',
    'delete_success': 'Deleted',
    'confirm': 'Confirm',
    'group_created_success': 'Group created',
    'asset_submitted': 'Asset submitted',
    'prompt_reference_hint_start': 'In prompt use ',
    'prompt_reference_hint_end': ' to reference materials (N = thumbnail index)',
'go_creative': 'Go to Creative Inspiration',
    'select_model_first': 'Please select model version',
    'reference_video': 'Reference Video',
    'reference_audio': 'Reference Audio',
    'select_from_library': 'Select from Library',
    'select_from_library_video': 'Select Video from Library',
    'cleared_all_prefix': 'Cleared all',
    'my_works': 'My Works',
    'aigc_asset_group': 'AIGC Assets',
    'real_person_group': 'Real Person Assets',
    'convert_to_aigc_group': 'Convert to AIGC Group',
    'select_target_group': 'Select Target Group',
    'asset_name': 'Asset Name',
    'enter_asset_name': 'Enter asset name',
    'confirm_convert': 'Confirm Convert',
    'asset_group_list': 'Asset Group List',
    'back_to_group_list': 'Back to Groups',
    'group_name': 'Group Name',
    'group_id': 'Group ID',
    'real_person_group_list': 'Real Person Group List',
    'no_real_person_groups': 'No real person groups',
    'no_asset_groups': 'No asset groups',
    'no_assets_in_group': 'No assets in group',
    'image_expiry_1h': 'Image signed URLs expire in 1 hour',
    'video_expiry_24h': 'Video material kept for 24 hours',
    'upload_asset': 'Upload Asset',
    'upload': 'Upload',
    'select_from_library_frame': 'Select from Library',
    'max_count': 'Max {count}',
    'group_count': 'Groups',
    'group': 'group(s)',
    'paste_asset_url': 'Paste asset URL',
    'select_from_works': 'From Works',
    'image_expired': 'Image expired',
    'audio': 'Audio',
    'asset_name': 'Asset Name',
    'enter_asset_name': 'Enter asset name',
    'create_real_person_group': 'Create Group (Verification Required)',
    'recently_generated': 'Recently generated, available for 24h',
    'remaining_time': 'Remaining',
    'submit_url': 'Submit URL',
    'reference': 'Use',
    'create_real_person_group': 'Create Group (Verification)',
    'hours_short': 'h',
    'minutes_short': 'min',
    'remark': 'Remark/Description',
    'optional': 'Optional',
    'liveness_verification': 'Liveness Verification',
    'confirm_delete_asset': 'Delete this asset?',
    'confirm_delete': 'Confirm delete?',
    'delete_success': 'Deleted',
    'confirm': 'Confirm',
    'group_created_success': 'Group created',
    'asset_submitted': 'Asset submitted',
    'prompt_reference_hint_start': 'In prompt use ',
    'prompt_reference_hint_end': ' to reference materials (N = thumbnail index)',
'go_creative': 'Go to Creative Inspiration',
    'mode_full_reference_disabled': 'Full reference not supported by this model',

    // Asset Library
    'person_asset_warning': 'Person images must be uploaded to Asset Library',
    'person_asset_desc': 'Reference images containing real faces must be uploaded to the asset library for review.',
    'manage_assets': 'Manage Assets',
    'asset_library_title': 'Asset Library',
    'asset_group': 'Asset Group',
    'new_group_name': 'Group Name',
    'create_group': 'Create Group',
    'add_asset': 'Add Asset',
    'asset_url_placeholder': 'Asset image URL',
    'submit_asset': 'Submit Asset',
    'asset_list': 'Asset List',
    'select_group_first': 'Select a group to view assets',
    'reference': 'Use',
    'asset_processing': 'Processing',
    'asset_active': 'Active',
    'asset_failed': 'Failed',
    'asset_upload_hint': 'Person images must be reviewed through the asset library before use. Upload and wait for Active status to reference in generation.',

    // Download
    'downloading': 'Downloading...',
    'download_success': 'Download complete',
    'download_failed': 'Download failed',
    'packaging_zip': 'Packaging...',
    'download_all_zip': 'Download All (ZIP)',
    'download_image': 'Download Image',
    'download_current': 'Download Current',
    'download_video': 'Download Video',


    // Playground / Model Training
    'playground': 'Model Training',
    'playground_desc': 'Test and optimize your model parameters',
    'my_training': 'My Training',
    'continue_training': 'Continue Training',
    'use_now': 'Use Now',
    'go_train': 'Go Train',
    'go_train_now': 'Go Train',
    'no_trained_models': 'You have no trained models yet',
    'view_all': 'View All',
    'save_training_model': 'Save Training Model',
    'model_name': 'Model Name',
    'enter_model_name': 'Enter model name',
    'description': 'Description',
    'enter_description': 'Describe the purpose of this configuration (optional)',
    'base_model': 'Base Model',
    'current_params': 'Current Parameters',
    'public_share': 'Public Share',
    'public_share_desc': 'Other users can see this configuration in the Model Square when enabled',
    'save_success': 'Training model saved',
    'save_failed': 'Save failed',
    'load_config': 'Loaded config',
    'config_params': ' parameters, continue adjusting training',
    'dialogue_cleared': 'Dialogue cleared',
    'copied_to_clipboard': 'Copied to clipboard',
    'conversation_saved': 'Conversation saved',
    'request_cancelled': 'Request cancelled',
    'request_failed': 'Request failed',
    'load_failed': 'Load failed',
    'model_selection': 'Model Selection',
    'parameter_config': 'Parameter Configuration',
    'temperature_desc': 'Controls randomness. Lower values are more deterministic, higher values are more creative',
    'max_tokens_desc': 'Maximum generated tokens',
    'top_p_desc': 'Nucleus sampling, controls the token range to consider',
    'frequency_penalty_desc': 'Reduces repetition of already appeared tokens',
    'presence_penalty_desc': 'Encourages discussion of new topics',
    'stream_mode': 'Stream Output',
    'stream_desc': 'Stream output, real-time display of generated content',
    'system_prompt': 'System Prompt',
    'enter_system_prompt': 'Set system prompt...',
    'start_conversation': 'Start a conversation! Choose a model, adjust parameters, and send a message.',
    'input_placeholder': 'Type a message... (Shift+Enter for new line, Enter to send)',
    'streaming_mode': 'Streaming',
    'sync_mode': 'Sync',
    'uses': 'uses',
    'used_count': 'Used',
    'click_load_config': 'Click to load config',
    'no_description': 'No description',
    'save_training_model_tip': 'After debugging the parameters, click "Save Training Model" to save the configuration.',
    'save_training_model_tip2': 'Training models will be displayed in',
    'save_training_model_tip3': '.',
    'load_models_failed': 'Failed to load models',
    'trained_config_loaded': 'Config loaded',
    'trained_config_params': ' parameters, continue adjusting training',
    'config_loaded': 'Config loaded',
    'config_params': ' parameters',
    'enter_config_name': 'Please enter a name',
    'all_models': 'All Models',
    'all_providers': 'All Providers',
    'select_role': 'Select Role',
    'select_role_placeholder': 'Select a preset role (optional)',
    'you': 'You',
    'select_provider': 'Select Provider',
    // Data Flow
    'data_flow': 'Data Flow',
    'request_data': 'Request Data',
    'response_data': 'Response Data',
    'model_params_used': 'Model Parameters Used',
    'trained_config': 'Trained Config',
    'preset': 'Preset',
    'parameters': 'Parameters',
    'actual_request_body': 'Actual Request Body',
    'usage': 'Usage',
    'response_content': 'Response Content',
    'no_response_yet': 'No response data yet. Send a message to view.',
    'data_flow_tip': 'This panel shows the actual request parameters and response data for debugging and verifying if the correct training parameters and preset roles are used.',

    'batch_tip_title': 'Batch Processing Guide',
    'batch_tip_1': '1. Supports /v1/chat/completions and /v1/embeddings endpoints',
    'batch_tip_2': '2. Requires uploading input file in JSONL format',

    // Presets
    'preset_management': 'Preset Management',
    'preset_market': 'Preset Market',
    'my_presets': 'My Presets',
    'create_preset': 'Create Preset',
    'edit_preset': 'Edit Preset',
    'preset_name': 'Preset Name',
    'enter_preset_name': 'Please enter preset name',
    'preset_description': 'Description',
    'enter_description': 'Please enter description',
    'preset_prompt': 'Prompt',
    'enter_prompt': 'Please enter prompt',
    'variables': 'Variables',
    'variables_placeholder': 'e.g., {{name}}, {{date}}',
    'binding_model': 'Bound Model',
    'binding_model_placeholder': 'Leave empty to not bind to a specific model',
    'trained_model': 'Trained Model',
    'trained_model_name': 'Trained Model',
    'trained_model_bound_model': 'Model',
    'preset_label': 'Preset',
    'preset_model': 'Preset Model',
    'preset_bound_model': 'Preset Model',
    'visibility': 'Visibility',
    'public': 'Public',
    'private': 'Private',
    'search_preset': 'Search presets...',
    'all_categories': 'All Categories',
    'cat_code': 'Coding',
    'cat_writing': 'Writing',
    'cat_analysis': 'Analysis',
    'cat_product': 'Product',
    'cat_education': 'Education',
    'cat_research': 'Research',
    // Research related presets
    'research_paper_analyzer': 'Paper Analysis Assistant',
    'research_paper_analyzer_desc': 'Helps analyze and summarize academic papers, extracting key information and research methods',
    'literature_review': 'Literature Review Generator',
    'literature_review_desc': 'Assists in writing literature reviews, systematically organizing and reviewing related research',
    'data_analysis_helper': 'Data Analysis Assistant',
    'data_analysis_helper_desc': 'Helps with data cleaning, statistical analysis and visualization suggestions',
    // Preset parameters guide
    'preset_params_guide': 'Preset Parameters Guide',
    'preset_params_temperature': 'Temperature: Controls output randomness. Lower values make output more deterministic, higher values create more creative variations',
    'preset_params_max_tokens': 'Max Tokens: Limits the maximum length of a single response, affecting the level of detail',
    'preset_params_top_p': 'Top P (Nucleus Sampling): Another way to control randomness, lower values make selections more concentrated',
    'preset_params_system_prompt': 'System Prompt: Defines the AI assistant role, behavior rules, and context background',
    'cat_translation': 'Translation',
    'cat_others': 'Others',
    'no_presets': 'No presets yet',
    'use_preset': 'Use Preset',
    'using_preset': 'Using preset',
    'usage_count': 'Usage Count',
    'created_at': 'Created At',
    'description': 'Description',
    'view': 'View',
    'copy_success': 'Copied successfully',
    'copy_failed': 'Copy failed',
    'make_public_success': 'Made public',
    'make_private_success': 'Made private',
    'load_failed': 'Load failed',
    'create_success': 'Created successfully',
    'create_failed': 'Create failed',
    'update_success': 'Updated successfully',
    'update_failed': 'Update failed',
    'delete_success': 'Deleted successfully',
    'delete_failed': 'Delete failed',
    'operation_failed': 'Operation failed',
    'confirm_delete': 'Are you sure you want to delete this preset?',
    'close': 'Close',
    // Like related
    'my_liked_presets': 'My Liked',
    'like_count': 'Likes',
    'likes': 'likes',
    'like': 'Like',
    'unlike': 'Unlike',
    'like_success': 'Liked successfully',
    'unlike_success': 'Removed like',
    'usage': 'uses',
    'batch_tip_3': '3. To protect your data privacy, result files are retained for 7 days after completion and then permanently deleted',
    'batch_help_title': 'Batch Processing User Guide',
    'batch_help_quick_start': 'Quick Start',
    'batch_help_prepare_file': '1. Prepare JSONL File',
    'batch_help_prepare_file_desc': 'Batch processing requires a JSONL format file with one complete request object per line.',
    'batch_help_param_desc': 'Parameter Description',
    'batch_help_custom_id': 'Custom identifier for each request',
    'batch_help_method': 'HTTP method, such as POST',
    'batch_help_url': 'API endpoint path, such as /v1/chat/completions',
    'batch_help_body': 'Request body content, same as standard API call',
    'batch_help_supported_api': 'Supported API Types',
    'batch_help_api_note': 'Each request body needs to specify the specific model name',
    'batch_help_example_chat': 'Example: Chat Completion',
    'batch_help_view_result': 'View Results',
    'batch_help_view_result_desc': 'After the task is completed, click the "Download" button to get the result file. The result file is also in JSONL format.',
    'batch_help_limit': 'Limitations',
    'batch_help_limit_1': 'Maximum file size is 100MB',
    'batch_help_limit_2': 'Maximum number of requests depends on account type',
    'batch_help_limit_3': 'To protect data privacy, result files are retained for 7 days after completion and then permanently deleted',

    // Route Strategy
    'route_strategy': 'Route Strategy',
    'route_strategy_desc': 'Select route strategy for API requests',
    'strategy_lowest_price': 'Lowest Price',
    'strategy_lowest_price_desc': 'Automatically select the lowest priced available model',
    'strategy_quality_first': 'Quality First',
    'strategy_quality_first_desc': 'Prefer models with higher quality scores',
    'strategy_load_balance': 'Load Balance',
    'strategy_load_balance_desc': 'Distribute requests evenly across multiple models',
    'strategy_fallback': 'Fallback',
    'strategy_fallback_desc': 'Try models in order until one succeeds',
    'strategy_random': 'Random',
    'strategy_random_desc': 'Randomly select from available models',
    'route_strategy_param': 'Route Strategy Parameter',
    'route_strategy_tip': 'Pass via header: x-router-strategy or body: router_strategy',

    'no_batches': 'No batch tasks',
    'create_first_batch': 'Create your first batch task',
    'input_file': 'Input File',
    'output_file': 'Output File',
    'error_file': 'Error File',
    'confirm_cancel_batch': 'Confirm Cancel Batch',
    'cancel_batch_warning': 'Are you sure you want to cancel this batch task? This action cannot be undone.',
    'delete_batch_warning': 'The task and its input/output files will be permanently deleted. Are you sure?',
    'delete_success': 'Deleted successfully',
    'delete_failed': 'Delete failed',
    'batch_cancelled': 'Batch cancelled',
    'cancel_failed': 'Cancel failed',
    
    // API Keys
    'email_mismatch': 'Email does not match',
    'api_key_reset': 'API Key has been reset',
    'reset_failed': 'Reset failed',
    'reset_failed_retry': 'Reset failed, please try again later',
    'api_key_management': 'API Key Management',
    'your_api_key': 'Your API Key',
    'reset_api_key': 'Reset API Key',
    'reset_warning': 'The old key will be invalid after reset',
    'confirm_email': 'Please enter your email to confirm',
    'code_example': 'Code Example',
    'api_key_desc': 'Manage your API keys for accessing platform APIs',
    'key_name': 'Key Name',
    'api_key': 'API Key',
    'status': 'Status',
    'created_at': 'Created At',
    'last_used': 'Last Used',
    'actions': 'Actions',
    'active': 'Active',
    'inactive': 'Inactive',
    'no_api_keys': 'No API Keys',
    'create_first_key': 'Create your first API key',
    'key_created': 'Key created successfully',
    'key_deleted': 'Key deleted successfully',
    'copy_success': 'Copied successfully',
    'copy_failed': 'Copy failed',
    'confirm_delete': 'Confirm Delete',
    'confirm_delete_msg': 'Are you sure you want to delete this API key? This action cannot be undone.',
    
    // Bills
    'bill_management': 'Bill Management',
    'bill_desc': 'View your consumption and recharge records',
    'bill_type': 'Type',
    'type': 'Type',
    'amount': 'Amount',
    'balance_before': 'Balance (Before)',
    'balance_after': 'Balance (After)',
    'remark': 'Remark',
    'all': 'All',
    'consumption': 'Consumption',
    'recharge': 'Recharge',
    'refund': 'Refund',
    'no_bills': 'No bills yet',
    
    // Chat suggestions
    'suggestion_spring': 'Write a poem about spring',
    'suggestion_quantum': 'Explain quantum computing',
    'suggestion_python': 'Help me write a Python crawler',
    
    // Merchant Center
    'affiliate_program': 'Merchant Center',
    'affiliate_desc': 'Share link and earn commissions',
    'affiliate_link': 'Affiliate Link',
    'your_invitation_link': 'Your Exclusive Invitation Link',
    'referral_rewards_desc': 'When friends register through your link, you will receive referral rewards',
    'merchant_referral_bonus': 'Merchant Referral Bonus',
    'friend_referral_bonus': 'Friend Registration Bonus',
    'commission_rate': 'Commission Rate',
    'total_commission': 'Total Commission',
    'withdrawable': 'Withdrawable',
    'invited_users': 'Invited Users',
    'affiliate_rules': 'Affiliate Rules',
    'commission_records': 'Commission Records',
    'withdraw': 'Withdraw',
    'apply_withdraw': 'Apply Withdraw',
    'withdraw_amount': 'Withdraw Amount',
    'withdraw_account': 'Payment Account',
    'withdraw_note': 'Note',
    
    // Settings
    'account_settings': 'Account Settings',
    'basic_info': 'Basic Info',
    'email': 'Email',
    'phone': 'Phone',
    'change_password': 'Change Password',
    'old_password': 'Current Password',
    'new_password': 'New Password',
    'confirm_password': 'Confirm Password',
    'password_mismatch': 'Passwords do not match',
    'password_changed': 'Password changed successfully',
    'security_settings': 'Security Settings',
    'login_password': 'Login Password',
    'enter_current_password': 'Enter current password',
    'enter_new_password': 'Enter new password',
    'password_min_length': 'Password must be at least 8 characters',
    'password_hint_input': 'At least 8 characters, letters and numbers recommended',
    'confirm_new_password': 'Confirm new password',
    'edit': 'Edit',
    
    // Top Up
    'top_up_title': 'Account Top Up',
    'select_amount': 'Select Amount',
    'custom_amount': 'Custom Amount',
    'payment_method': 'Payment Method',
    'alipay': 'Alipay',
    'wechat': 'WeChat Pay',
    'bank_transfer': 'Bank Transfer',
    'proceed_payment': 'Proceed to Payment',
    
    // Back to home
    'back_to_home': 'Back to Home',
    
    // Consumption Records
    'consumption_records': 'Consumption Records',
    'total_consumption': 'Total Consumption',
    'total_records': 'Total',
    'records': 'records',
    'record': 'record',
    'no_consumption_records': 'No consumption records',
    'recharge_records': 'Recharge Records',
    'total_recharge': 'Total Recharge',
    'no_recharge_records': 'No recharge records',
    'transaction_records': 'Transaction Records',
    'admin_adjustment': 'Admin Adjustment',
    'model': 'Model',
    'input_tokens': 'Input Tokens',
    'output_tokens': 'Output Tokens',

    // Settings
    'normal': 'Normal',
    'registered_at': 'Registered At',
    'login_password': 'Login Password',
    'password_hint': 'Change password regularly for security',
    'help_support': 'Help & Support',
    'api_docs': 'API Documentation',
    'api_docs_desc': 'Complete API guide and examples',
    'view_docs': 'View Docs',
    'billing_info': 'Billing Info',
    'billing_info_desc': 'Pay by token usage, accurate billing',
    'learn_more': 'Learn More',
    'tech_support': 'Technical Support',
    'contact_email': 'Questions? Email',
    'enter_current_password': 'Enter current password',
    'enter_new_password': 'Enter new password',
    'password_min_length': 'Password must be at least 8 characters',
    'password_hint_input': 'At least 8 characters, letters and numbers recommended',
    'confirm_new_password': 'Confirm new password',
    'saving': 'Saving...',
    
    // Recharge
    'payment_success': 'Payment successful! Balance added',
    'payment_cancelled': 'Payment cancelled',
    'fetch_balance_error': 'Failed to fetch balance',
    'min_recharge': 'Minimum recharge amount is $1',
    'create_order_failed': 'Failed to create payment order',
    'creating_order': 'Creating payment order...',
    'recharge_failed': 'Recharge failed',
    'recharge_error': 'Recharge request failed, please try again later',
    'current_balance': 'Current Balance',
    'account_normal': 'Account Normal',
    'instant_credit': 'Instant credit',
    'select_payment_method': 'Select Payment Method',
    'credit_debit': 'Credit/Debit Card',
    'or_custom_amount': 'Or custom amount',
    'recharge_now': 'Recharge Now',
    'payment_info': 'Payment Information',
    'payment_info_1': 'Supports credit/debit cards (via Stripe secure payment)',
    'payment_info_2': 'Supports PayPal account payment',
    'payment_info_3': 'Instant credit, available for all models',
    'payment_info_4': 'Balance never expires',
    'payment_info_5': 'For questions, please contact support',
    
    // Affiliate
    'fetch_affiliate_error': 'Failed to fetch affiliate info',
    'referral_code_copied': 'Referral code copied to clipboard',
    'referral_link_copied': 'Referral link copied to clipboard',
    'level_bronze': 'Bronze',
    'level_silver': 'Silver',
    'level_gold': 'Gold',
    'level_platinum': 'Platinum',
    'level_normal': 'Normal',
    'active_status': 'Active',
    'pending_status': 'Pending',
    'consumption_amount': 'Consumption',
    'my_commission': 'My Commission',
    'commission_income': 'Commission',
    'withdrawal_type': 'Withdrawal',
    'completed': 'Completed',
    'processing': 'Processing',
    'time': 'Time',
    'users': 'users',
    'total': 'Total',
    'copy': 'Copy',
    'referral_code': 'Referral Code',
    'promo_info': 'Promotion Info',
    'promo_tip': 'Share your link, earn',
    'promo_tip_2': 'of referred users\' spending',
    'referred_users': 'Referred Users',
    
    // API Keys
    'current_key': 'Current Key',
    'reset': 'Reset',
    'api_key_warning': 'Please keep your API Key safe. Do not expose it in client-side code or public repositories.',
    'no_api_key': 'No API Key generated',
    'integration_guide': 'Integration Guide',
    'openai_compatible': 'OpenAI Compatible API',
    'openai_compatible_desc': 'This platform provides OpenAI-compatible API. You can:',
    'openai_feature_1': 'Use OpenAI SDK directly (just modify baseURL and apiKey)',
    'openai_feature_2': 'Support streaming output (SSE)',
    'openai_feature_3': 'Multi-model switching, billed by actual token usage',
    'key_tip': 'This list shows all your API Keys. API Keys are only visible and copyable at creation time - please save them securely. Do not share your API Keys with others or expose them in browser or client code. To protect your account, we may automatically disable API Keys found publicly exposed.',
    'api_key_copied': 'API Key copied',
    'api_key_save_reminder': 'Please make sure to save your API Key! You will not be able to view the full Key again after closing this dialog.',
    'request_example': 'Request Example',
    'copied': 'Copied',
    'copy_code': 'Copy Code',
    'standard_api': 'Standard API format',
    'sse_streaming': 'SSE Streaming',
    'realtime_output': 'Real-time output',
    'pay_per_use': 'Pay per Use',
    'accurate_billing': 'Accurate to 6 decimal places',
    'available_models': 'Available Models',
    'model_hint': 'Specify the model field in request parameters to use different models',
    'model_name': 'Model',
    'display_name': 'Display Name',
    'provider': 'Provider',
    'streaming_output': 'Streaming',
    'confirm_reset_api_key': 'Confirm Reset API Key',
    'confirm_reset': 'Confirm Reset',
    'reset_irreversible': 'This action is irreversible! The old key will become invalid immediately.',
    'enter_email_confirm': 'Please enter your email',
    'to_confirm': 'to confirm',
    
    // Dashboard
    'created': 'Created',
    'create_now': 'Create',
    'create_call': 'Create Key',
    'referral_bonus': 'Referral Bonus',
    'up_to_20': 'Up to 20%',
    'new_chat': 'New Chat',
    'select_model': 'Select Model',
    'select_model_first': 'Please select a model first',
    'fullscreen': 'Fullscreen',
    'exit_fullscreen': 'Exit Fullscreen',
    'try_asking': 'Try asking:',
    'stop': 'Stop',
    'confirm_edit': 'Confirm Edit',
    'edit_confirm_msg': 'After saving, all messages after this one will be deleted and a new AI response will be generated. Continue?',
    'regenerate': 'Regenerate',
    'request_stopped': 'Request stopped',
    'request_timeout': 'Request timeout',
    'balance_insufficient': 'Insufficient Balance',
    'balance_insufficient_msg': 'Your account balance is insufficient. Please recharge and try again.',
    'balance_insufficient_tip': 'New users get free credits upon registration',
    'credit_limit_exceeded': 'Credit Limit Exceeded',
    'credit_limit_exceeded_msg': 'This API Key has exceeded its credit limit. Please adjust the limit in API Keys page or create a new Key.',
    'manage_api_keys': 'Manage API Keys',
    'select_provider': 'Select Provider',
    'all_providers': 'All Providers',
    
    // Affiliate
    'not_affiliate': 'You are not an affiliate yet. Contact admin to apply.',
    'no_referrals': 'No referrals yet',
    'no_commission_records': 'No commission records',
    'withdraw_success': 'Withdrawal request submitted',
    'withdraw_failed': 'Withdrawal failed',
    'enter_amount': 'Please enter amount',
    'min': 'Min',
    'min_withdraw': 'Minimum withdrawal is $10',
    'select_payment': 'Please select payment method',
    'enter_account': 'Please enter payment account',
    'withdraw_account_placeholder': 'Email or account info',

    // Model Square
    'model_square_title': 'Explore AI Models, Everything You Need',
    'model_square_subtitle': 'Discover various AI models and find the best solution for your needs',
    'search_models': 'Search Models',
    'hot_models': 'Hot Models',
    'all_models': 'All Models',
    'model_type': 'Model Type',
    'use_case': 'Use Case',
    'clear_filters': 'Clear Filters',
    'price': 'Price',
    'input_price': 'Input',
    'output_price': 'Output',
    'no_models_found': 'No matching models found',
    'try_adjusting': 'Try adjusting search criteria or filters',
    'view_details': 'View Details',
    'start_chat': 'Start Chat',
    'tokens_per_1k': 'per 1K tokens',

    // Feedback
    'feedback_title': 'Feedback',
    'feedback_desc': 'Have an issue? Submit a ticket and we will handle it soon',
    'feedback_type': 'Feedback Type',
    'bug_report': 'Bug Report',
    'feature_request': 'Feature Request',
    'general_feedback': 'General Feedback',
    'title': 'Title',
    'description': 'Description',
    'contact_info': 'Contact Info (Optional)',
    'submit_feedback': 'Submit Feedback',
    'feedback_success': 'Feedback Submitted',
    'feedback_success_msg': 'Thank you for your feedback, we will process it soon',
    'my_tickets': 'My Tickets',
    'ticket_status': 'Status',
    'ticket_pending': 'Pending',
    'ticket_processing': 'Processing',
    'ticket_resolved': 'Resolved',
    'ticket_closed': 'Closed',
    'no_tickets': 'No tickets',
    'ticket_detail': 'Ticket Detail',
    'reply': 'Reply',
    'send_reply': 'Send Reply',

    // Customer Service
    'contact_customer_service': 'Customer Service',
    'fetch_customer_service_failed': 'Failed to fetch customer service config',
    'wechat_service': 'WeChat Service',
    'wechat_customer_id': 'WeChat Customer ID',
    'wechat_id': 'WeChat ID',
    'copy_wechat_customer_id': 'Copy WeChat Customer ID',
    'wechat_copied': 'WeChat ID copied',
    'model_recommend': 'Model Recommend',
    'no_description': 'No description',
    'please_enter_feedback': 'Please enter feedback',
    'please_login_first': 'Please login first',
    'feedback_submitted': 'Feedback submitted',
    'no_contact_info': 'No contact info',
    'contact_admin_config': 'Please contact admin to configure',
    'scan_or_search': 'Scan or search WeChat ID to add customer service',
    'wechat_copied': 'WeChat ID copied',
    'copied_to_clipboard': 'Copied to clipboard',
    'copy_failed_manual': 'Copy failed, please copy manually',

    // Login/Register
    'login': 'Login',
    'create_account': 'Create Account',
    'register_get_free': 'Register to get free credits',
    'password_min_8': 'Password must be at least 8 characters',
    'set_password': 'Set password (at least 8 characters)',
    'verification_code': 'Verification Code',
    'remember_me': 'Remember me',
    'forgot_password': 'Forgot password?',
    'find_password': 'Find Password',
    'enter_registered_email': 'Enter your registered email, we will send verification code',
    'set_new_password': 'Set new password (at least 8 characters)',
    'passwords_do_not_match': 'Passwords do not match',
    'reset_success': 'Password reset successful, please login with new password',

    // API Keys
    'create_new_key': 'Create New Key',
    'please_enter_key_name': 'Please enter key name',
    'created_success_copy': 'Created successfully, please copy and save',
    'created_failed': 'Create failed',
    'created_failed_retry': 'Create failed, please try again',
    'deleted_success': 'Deleted successfully',
    'deleted_failed': 'Delete failed',
    'deleted_failed_retry': 'Delete failed, please try again',
    'operation_failed': 'Operation failed',
    'operation_failed_retry': 'Operation failed, please try again',
    'i_have_saved': 'I have saved',
    'edit_key_name': 'Edit Key Name',
    'please_enter_new_name': 'Please enter new name',
    'key_updated': 'Key updated',
    'update_failed': 'Update failed',
    'ticket_pending': 'Pending',
    'ticket_processing': 'Processing',
    'ticket_resolved': 'Resolved',
    'ticket_closed': 'Closed',
    'no_tickets': 'No tickets yet',
    'ticket_detail': 'Ticket Detail',
    'reply': 'Reply',
    'send_reply': 'Send Reply',

    // Merchant Center
    'merchant_title': 'Merchant Center',
    'merchant_desc': 'Share link and earn commissions',
    'referral_link': 'Referral Link',
    'copy_link': 'Copy Link',
    'commission_rate': 'Commission Rate',
    'total_commission': 'Total Commission',
    'withdrawable': 'Withdrawable',
    'invited_users': 'Invited Users',
    'withdraw': 'Withdraw',
    'apply_withdraw': 'Apply Withdraw',
    'withdraw_amount': 'Withdraw Amount',
    'withdraw_account': 'Payment Account',
    'withdraw_note': 'Note',
    'commission_records': 'Commission Records',
    'no_commission': 'No commission records',
    'commission_rules': 'Commission Rules',
    'rule_1': 'Users who register through your referral link will generate {rate} of their spending as your commission',
    'rule_2': 'Commissions are calculated in real-time and can be withdrawn at any time',
    'rule_3': 'Minimum withdrawal amount is $10',

    // Dashboard
    'welcome_back': 'Welcome Back',
    'quick_start': 'Quick Start',
    'chat_with_ai': 'Chat with AI',
    'explore_models': 'Explore Models',
    'view_api_keys': 'View API Keys',
    'account_info': 'Account Info',
    'service_status': 'Service Status',
    'normal': 'Normal',
    'maintenance': 'Maintenance',

    // Price Compare
    'home': 'Home',
    'price_compare': 'Price Compare',
    'price_trend': 'Price Trend',
    'model_comparison': 'Model Comparison',
    'compare_result_explain': 'How to Understand Comparison Results',
    'compare_green_label': 'Green Label',
    'compare_green_tip': 'Lowest price among selected models',
    'compare_price_context': 'Input and output prices are compared separately to find the best in each category',
    'compare_overall_hint': 'Consider both price and context length to choose the model that best fits your needs',
    'compare_select_2_hint': 'Please select at least 2 models for comparison',
    'compare_select_min_2': 'Select multiple models for comprehensive evaluation to find the best solution',
    'compare_recommendation': 'Recommendation',
    'compare_best_input': '{model} has the best input price',
    'compare_no_best': 'Select multiple models for comprehensive evaluation',
    'total_models': 'Total Models',
    'selected_compare': 'Selected',
    'providers_count': 'Providers',
    'cheapest_input': 'Cheapest Input',
    'model_list': 'Model List',
    'filter_by_provider': 'Filter by Provider',
    'selected': 'Selected',
    'select_compare': 'Select',
    'compare': 'Compare',
    'select_models_for_trend': 'Please select at least 2 models to view price trends',
    'quick_compare': 'Quick Compare',
    'selected_models': 'Selected Models',
    'max_models_compare_warning': 'Maximum 4 models can be compared',
    'input_price': 'Input Price',
    'output_price': 'Output Price',
    'billing_type': 'Billing Type',
    'context_length': 'Context Length',
    'type': 'Type',
    'per_token': 'Per Token',
    'per_token_video': 'Per Token (Video)',
    'per_image': 'Per Image',
    'per_call': 'Per Call',
    'per_char': 'Per Char',
    'free': 'FREE',
    'price_compare_desc': 'Compare model prices and choose the most cost-effective option',
    'with_price': 'With Price',
    'filter_by_type': 'Filter by Type',
    'search_model': 'Search models...',
    'max_compare_tip': 'Select up to 4 models for comparison',
    'clear_all': 'Clear All',
    'clear': 'Clear',
    'total': 'Total',
    'lowest_price': 'Lowest Price',
    'select_models_hint': 'Select at least 2 models for comparison',

    // API Keys
    'create_new_key': 'Create New Key',
    'key_name': 'Key Name',
    'credit_limit': 'Credit Limit',
    'no_limit': 'No Limit',
    'key_created': 'Key Created',
    'key_deleted': 'Key Deleted',
    'confirm_delete_key': 'Are you sure you want to delete this API Key?',
    'delete_warning': 'This action cannot be undone. Apps using this key will no longer work.',
    'edit_key_name': 'Edit Key Name',
    'save': 'Save',
    'cancel': 'Cancel',
    
    // API Keys Page
    'my_api_keys': 'My API Keys',
    'create_key': 'Create Key',
    'name': 'Name',
    'limit': 'Limit',
    'used': 'Used/Limit',
    'created': 'Created',
    'actions': 'Actions',
    'disabled': 'Disabled',
    'enable': 'Enable',
    'enabled': 'Enabled',
    'disable': 'Disable',
    'delete': 'Delete',
    'unlimit': 'Unlimited',
    'no_keys_yet': 'No keys yet, click above to create',
    'please_enter_key_name': 'Please enter a key name',
    'key_name_example': 'e.g., Dev Test, Production',
    'key_name_hint': 'Set an easy-to-recognize name for tracking usage across different scenarios',
    'optional': 'Optional',
    'credit_limit_hint': 'When limit is reached, this key will be automatically disabled',
    'current_balance': 'Current Balance',
    'available_credit': 'Available Credit',
    'no_available_credit': 'Other keys have occupied all credit limit',
    'zero_no_limit': '0 = No limit',
    'key_created_success': 'Key Created Successfully',
    'copy_and_close': 'Copy & Close',
    'close': 'Close',
    'copy_save_key': 'Please copy and save the Key immediately',
    'key_show_once': 'This Key will only be shown once and cannot be viewed again',
    'update_success': 'Updated successfully',
    'update_failed': 'Update failed',
    'update_failed_retry': 'Failed to update, please try again',
    'created_success_copy': 'Created successfully, please copy and save',
    'created_failed': 'Failed to create',
    'created_failed_retry': 'Failed to create, please try again',
    'deleted_success': 'Deleted successfully',
    'deleted_failed': 'Delete failed',
    'deleted_failed_retry': 'Failed to delete, please try again',
    'operation_failed': 'Operation failed',
    'operation_failed_retry': 'Operation failed, please try again',
    'i_have_saved': 'I have saved',
    'please_enter_new_name': 'Please enter new name',
    'key_updated': 'Key updated',

    // Code tabs
    'tab_curl': 'cURL',
    'tab_python': 'Python (OpenAI SDK)',
    'tab_nodejs': 'Node.js (OpenAI SDK)',

    // Pagination
    'pagination_total': '{start}-{end} / {total}',
    'pagination_items_per_page': '/ page',
    'pagination_jump_to': 'Go to',
    'pagination_page': 'Page',
    'pagination_prev_page': 'Previous',
    'pagination_next_page': 'Next',
    'per_page': '/ page',
    'prev_page': 'Previous',
    'next_page': 'Next',
    'jump_to': 'Go to',
    'page': 'Page',

    // FullLayout Sidebar
    'expand_menu': 'Expand Menu',
    'collapse_menu': 'Collapse Menu',
    'collapse': 'Collapse',
    'back_to_console': 'Back to Console',

    // Bills
    'consumption_records': 'Consumption Records',
    'recharge_records': 'Recharge Records',
    'bonus_records': 'Bonus Records',
    'total_consumption': 'Total Consumption',
    'total_recharge': 'Total Recharge',
    'total_bonus': 'Total Bonus',
    'time': 'Time',
    'type': 'Type',
    'amount': 'Amount',
    'balance_before': 'Balance (Before)',
    'balance_after': 'Balance (After)',
    'remark': 'Remark',
    'no_records': 'No records',
    'consumption': 'Consumption',
    'recharge': 'Recharge',
    'bonus': 'Bonus',
    
    // Bills Page
    'transaction_records': 'Transaction Records',
    'order_no': 'Order No',
    'online': 'Online',
    'offline': 'Offline',
    'status': 'Status',
    'pending': 'Pending',
    'succeeded': 'Succeeded',
    'failed': 'Failed',
    'method': 'Method',
    'manual': 'Manual',
    'referee_email': 'Referee Email',
    'bonus_amount': 'Bonus Amount',
    'completed': 'Completed',
    'processing': 'Processing',
    'cancelled': 'Cancelled',
    'no_bonus_records': 'No bonus records yet. Share campaign links to invite friends and earn rewards',
    
    // Model Square
    'search_placeholder': 'Search models, providers, use cases, descriptions...',
    'hot_models_title': 'Hot Models',
    'models_count': 'models',
    'default_sort': 'Default Sort',
    'sort_by_size': 'By Size',
    'sort_by_price': 'By Price',
    'sort_by_context': 'By Context Length',
    'ascending': 'Asc',
    'descending': 'Desc',
    'search_results': 'Search Results',
    'all_models': 'All Models',
    'no_more_results': 'No more results',
    'release_date': 'Release Date',
    'input': 'Input',
    'output': 'Output',
    'capabilities': 'Capabilities',
    'context': 'Context',
    'size': 'Size',
    'no_description': 'No description',
    
    // Merchant Center
    'merchant_access_denied': 'Merchant Access Disabled',
    'merchant_access_denied_desc': 'Your merchant access has been disabled by admin. Please contact support if you have questions.',
    'back_to_home': 'Back to Home',
    'merchant_invite_link': 'Merchant Invite Link',
    'promo_code': 'Promo Code',
    'invite_link': 'Invite Link',
    'copy_link': 'Copy Link',
    'copy': 'Copy',
    'merchant_link_hint': 'Hint: Users who register through this link will automatically become your referrals',
    'cannot_generate_link': 'Cannot generate invite link',
    'available_campaigns': 'Available Campaigns',
    'campaign_hint': 'You can participate in these campaigns. Using campaign links to invite users earns both campaign rewards and commissions',
    'campaign_bonus': 'Campaign Bonus',
    'bonus_wallet': 'Bonus Wallet',
    'withdrawable_account': 'Withdrawable Account',
    'consumption_account': 'Consumption Account',
    'min_recharge_required': 'Min Recharge Required',
    'no_requirement': 'No Requirement',
    'remaining_slots': 'Remaining Slots',
    'unlimited': 'Unlimited',
    'campaign_time': 'Campaign Time',
    'ended': 'Ended',
    'ongoing': 'Ongoing',
    'closed': 'Closed',
    'campaign_link': 'Campaign Link',
    'total_commission': 'Total Commission',
    'withdrawable_balance': 'Withdrawable Balance',
    'referral_count': 'Referrals',
    'commission_rate': 'Commission Rate',
    'bank_card_info': 'Bank Card Info',
    'add_bank_card': 'Add Bank Card',
    'edit_bank_card': 'Edit Bank Card',
    'bank_name': 'Bank Name',
    'bank_branch': 'Branch Name',
    'account_name': 'Account Holder',
    'account_number': 'Card Number',
    'no_bank_card': 'No bank card bound yet',
    'add_now': 'Add Now',
    'commission_withdraw': 'Commission Withdrawal',
    'apply_withdraw': 'Apply Withdrawal',
    'min_withdraw': 'Min Withdrawal',
    'applied': 'Applied',
    'total_withdrawn': 'Total Withdrawn',
    'withdraw_hint_1': 'Withdrawal requests will be reviewed within 1-3 business days',
    'withdraw_hint_2': 'After approval, funds will be transferred to your bound bank card',
    'withdraw_hint_3': 'For questions, please contact platform support',
    'referral_list': 'Referral List',
    'no_referrals_hint': 'No referrals yet. Share your invite link with friends!',
    'commission_records': 'Commission Records',
    'no_commission_hint': 'No commission records yet. Commissions are generated when your referrals make purchases',
    'withdrawal_records': 'Withdrawal Records',
    'no_withdrawal_records': 'No withdrawal records',
    'referral_type': 'Referral Commission',
    'consumption_type': 'Consumption Commission',
    'commission_pending': 'Settled',
    'commission_paid': 'Paid',
    'commission_cancelled': 'Cancelled',
    'withdrawal_pending': 'Pending',
    'withdrawal_approved': 'Approved',
    'withdrawal_paid': 'Paid',
    'withdrawal_rejected': 'Rejected',
    'processed_at': 'Processed At',
    'enter_bank_name': 'Enter bank name',
    'enter_bank_branch': 'Enter branch name',
    'enter_account_name': 'Enter account holder name',
    'enter_account_number': 'Enter card number',
    'account_number_invalid': 'Please enter a valid card number (16-19 digits)',
    'enter_remark': 'Enter remarks (optional)',
    'withdrawal_apply': 'Apply for Commission Withdrawal',
    'withdrawal_desc': 'Withdrawal requests will be reviewed within 1-3 business days. After approval, funds will be transferred to your bound bank card.',
    'enter_amount': 'Enter amount',
    'amount_format_invalid': 'Please enter a valid amount format',
    'amount_exceeds_balance': 'Amount cannot exceed available balance',
    'amount_below_min': 'Amount cannot be less than',
    'receiving_bank': 'Receiving Bank',
    
    // Feedback
    'submit_ticket': 'Submit Ticket',
    'ticket_type': 'Type',
    'ticket_content': 'Content',
    'ticket_status': 'Status',
    'submit_time': 'Submit Time',
    'view_conversation': 'View Conversation',
    'continue_conversation': 'Continue Conversation',
    'no_feedback_records': 'No feedback records',
    'submit_failed': 'Submit failed, please try again',
    'ticket_closed_warning': 'Ticket is closed, cannot continue conversation',
    'send_failed': 'Send failed, please try again',
    'business_cooperation': 'Business Cooperation',
    'no_messages': 'No messages yet',
    'ticket_closed_cannot_reply': 'Ticket is closed, cannot continue conversation',
    'me': 'Me',
    'customer_service': 'Support',
    'name_optional': 'Name (Optional)',
    'enter_name': 'Enter your name',
    'enter_email': 'Enter your email',
    'enter_valid_email': 'Please enter a valid email',
    'issue_description': 'Issue Description',
    'enter_issue_description': 'Please describe your issue in detail',
    'ticket': 'Ticket',
    'enter_message': 'Enter message...',
    
    // Message Status
    'sending': 'Sending',
    'sent': 'Sent',
    'delivered': 'Delivered',
    'retry': 'Retry',
    'reconnecting': 'Reconnecting...',
    'connection_lost': 'Connection lost',
    'connection_restored': 'Connection restored',
    'message_syncing': 'Syncing messages...',
    'message_synced': 'Synced',
    
    // Dashboard
    'select_key': 'Select Key',
    'create_key_short': 'Create Key',
    'all_providers': 'All Providers',
    'no_model_available': 'No models available',
    'no_model_for_filter': 'No models match current filter',
    'history_conversations': 'History',
    'search_conversation': 'Search conversations...',
    'pin': 'Pin',
    'rename': 'Rename',
    'pinned': 'Pinned',
    'enter_chat': 'Enter Chat',
    'no_matching_conversations': 'No matching conversations',
    'no_conversations': 'No conversations yet',
    'collapse_conversation_list': 'Collapse List',
    'expand_conversation_list': 'Expand List',
    'video_generating': 'Video generating, click to check status',
    'processing': 'Processing...',
    'confirm_delete_conversation': 'Confirm Delete',
    'delete_conversation_msg': 'Are you sure you want to delete this conversation? This cannot be undone.',
    'conversation_deleted': 'Conversation deleted',
    'user_avatar': 'User avatar',
    'speech_speed': 'Speed',
    'ai_assistant': 'AI Assistant',
    'video_browser_unsupported': 'Your browser does not support video playback',
    'refresh_status': 'Refresh Status',
    'task_id': 'Task ID',
    'generated_image': 'Generated Image',
    'no_api_key': 'You don\'t have an API Key yet',
    'no_api_key_msg': 'To start chatting, you need to create an API Key first.',
    'no_api_key_step1': 'Click on the API Keys menu in the sidebar',
    'no_api_key_step2': 'Click the Create API Key button',
    'no_api_key_step3': 'Set a name and credit limit for the key',
    'no_api_key_step4': 'Return here to continue the conversation',
    'no_api_key_tip': 'After creating a key, the system will automatically select it for chatting.',
    
    // Playground / Model Training
    'playground': 'Model Training',
    'model_training': 'Model Training',
    'playground_desc': 'Test and optimize your model parameters',
    
    // User Guide
    'user_guide': 'User Guide',
    'guide_welcome': 'Welcome! Let\'s get you started quickly.',
    'step1_title': 'Browse Model Square',
    'step1_desc': 'Browse and filter AI models in the Model Square, explore features and pricing.',
    'step2_title': 'Model Training - Debug Parameters',
    'step2_desc': 'Select models in Model Training, adjust temperature, max_tokens and other parameters to find the optimal configuration.',
    'step3_title': 'Test in Workspace',
    'step3_desc': 'Test your configured parameters in the Workspace to verify the results.',
    'step4_title': 'Get API Key & Start Calling',
    'step4_desc': 'After testing, create an API Key and integrate AI capabilities into your applications.',
    'got_it': 'Got it, start using',
    'guide_tip': 'You can view the guide from the menu later',
    
    // Page Titles
    'user_console': 'User Console',
  }
};

// 获取翻译
export const t = (key, params = {}) => {
  const lang = localStorage.getItem('lang') || 'en';
  let text = translations[lang]?.[key] || translations['zh']?.[key] || key;
  
  // 替换参数 - 支持数组和对象格式
  if (params && typeof params === 'object') {
    const isArray = Array.isArray(params);
    Object.keys(params).forEach(param => {
      // 转义正则特殊字符
      const safeParam = isArray ? param : param.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(`\\{${safeParam}\\}`, 'g');
      text = text.replace(regex, params[param]);
    });
  }
  
  return text;
};

// 获取当前语言
export const getLang = () => localStorage.getItem('lang') || 'en';

// 设置语言
export const setLang = (lang) => {
  localStorage.setItem('lang', lang);
};

export default { t, getLang, setLang };
